var map = {
	"./CustomIcon/IconSuffix/default.svg": 846498,
	"./CustomIcon/IconSuffix/doc.svg": 73483,
	"./CustomIcon/IconSuffix/docx.svg": 945641,
	"./CustomIcon/IconSuffix/dwg.svg": 314408,
	"./CustomIcon/IconSuffix/jpg.svg": 44103,
	"./CustomIcon/IconSuffix/mp3.svg": 903896,
	"./CustomIcon/IconSuffix/mp4.svg": 878610,
	"./CustomIcon/IconSuffix/pdf.svg": 466307,
	"./CustomIcon/IconSuffix/png.svg": 634115,
	"./CustomIcon/IconSuffix/ppt.svg": 189338,
	"./CustomIcon/IconSuffix/pptx.svg": 369543,
	"./CustomIcon/IconSuffix/rar.svg": 588458,
	"./CustomIcon/IconSuffix/tiff.svg": 401368,
	"./CustomIcon/IconSuffix/txt.svg": 387071,
	"./CustomIcon/IconSuffix/xls.svg": 471731,
	"./CustomIcon/IconSuffix/xlsx.svg": 551763,
	"./CustomIcon/Number/0.svg": 840774,
	"./CustomIcon/Number/1.svg": 27166,
	"./CustomIcon/Number/2.svg": 561833,
	"./CustomIcon/Number/3.svg": 105595,
	"./CustomIcon/Number/4.svg": 450509,
	"./CustomIcon/Number/5.svg": 56025,
	"./CustomIcon/Number/6.svg": 979233,
	"./CustomIcon/Number/7.svg": 661442,
	"./CustomIcon/Number/8.svg": 868519,
	"./CustomIcon/Number/9.svg": 60555,
	"./CustomIcon/Number/point.svg": 915183,
	"./CustomIcon/QweatherIcons/100-fill.svg": 506941,
	"./CustomIcon/QweatherIcons/100.svg": 842794,
	"./CustomIcon/QweatherIcons/1001.svg": 537771,
	"./CustomIcon/QweatherIcons/1002.svg": 802975,
	"./CustomIcon/QweatherIcons/1003.svg": 403686,
	"./CustomIcon/QweatherIcons/1004.svg": 55810,
	"./CustomIcon/QweatherIcons/1005.svg": 392566,
	"./CustomIcon/QweatherIcons/1006.svg": 821755,
	"./CustomIcon/QweatherIcons/1007.svg": 800940,
	"./CustomIcon/QweatherIcons/1008.svg": 900981,
	"./CustomIcon/QweatherIcons/1009.svg": 906472,
	"./CustomIcon/QweatherIcons/101-fill.svg": 753840,
	"./CustomIcon/QweatherIcons/101.svg": 111087,
	"./CustomIcon/QweatherIcons/1010.svg": 397314,
	"./CustomIcon/QweatherIcons/1011.svg": 535601,
	"./CustomIcon/QweatherIcons/1012.svg": 954532,
	"./CustomIcon/QweatherIcons/1013.svg": 420664,
	"./CustomIcon/QweatherIcons/1014.svg": 100928,
	"./CustomIcon/QweatherIcons/1015.svg": 890827,
	"./CustomIcon/QweatherIcons/1016.svg": 277140,
	"./CustomIcon/QweatherIcons/1017.svg": 373093,
	"./CustomIcon/QweatherIcons/1018.svg": 328750,
	"./CustomIcon/QweatherIcons/1019.svg": 171806,
	"./CustomIcon/QweatherIcons/102-fill.svg": 119627,
	"./CustomIcon/QweatherIcons/102.svg": 471410,
	"./CustomIcon/QweatherIcons/1020.svg": 221322,
	"./CustomIcon/QweatherIcons/1021.svg": 659932,
	"./CustomIcon/QweatherIcons/1022.svg": 257515,
	"./CustomIcon/QweatherIcons/1023.svg": 889809,
	"./CustomIcon/QweatherIcons/1024.svg": 512788,
	"./CustomIcon/QweatherIcons/1025.svg": 34892,
	"./CustomIcon/QweatherIcons/1026.svg": 576649,
	"./CustomIcon/QweatherIcons/1027.svg": 24899,
	"./CustomIcon/QweatherIcons/1028.svg": 369602,
	"./CustomIcon/QweatherIcons/1029.svg": 602465,
	"./CustomIcon/QweatherIcons/103-fill.svg": 105504,
	"./CustomIcon/QweatherIcons/103.svg": 501199,
	"./CustomIcon/QweatherIcons/1030.svg": 517096,
	"./CustomIcon/QweatherIcons/1031.svg": 7821,
	"./CustomIcon/QweatherIcons/1032.svg": 678447,
	"./CustomIcon/QweatherIcons/1033.svg": 207885,
	"./CustomIcon/QweatherIcons/1034.svg": 592491,
	"./CustomIcon/QweatherIcons/1035.svg": 187684,
	"./CustomIcon/QweatherIcons/1036.svg": 59058,
	"./CustomIcon/QweatherIcons/1037.svg": 622458,
	"./CustomIcon/QweatherIcons/1038.svg": 874795,
	"./CustomIcon/QweatherIcons/1039.svg": 816934,
	"./CustomIcon/QweatherIcons/104-fill.svg": 516315,
	"./CustomIcon/QweatherIcons/104.svg": 243928,
	"./CustomIcon/QweatherIcons/1040.svg": 418436,
	"./CustomIcon/QweatherIcons/1041.svg": 340909,
	"./CustomIcon/QweatherIcons/1042.svg": 634317,
	"./CustomIcon/QweatherIcons/1043.svg": 396,
	"./CustomIcon/QweatherIcons/1044.svg": 900238,
	"./CustomIcon/QweatherIcons/1045.svg": 345374,
	"./CustomIcon/QweatherIcons/1046.svg": 435469,
	"./CustomIcon/QweatherIcons/1047.svg": 670006,
	"./CustomIcon/QweatherIcons/1048.svg": 623039,
	"./CustomIcon/QweatherIcons/1049.svg": 922057,
	"./CustomIcon/QweatherIcons/1050.svg": 348763,
	"./CustomIcon/QweatherIcons/1051.svg": 212855,
	"./CustomIcon/QweatherIcons/1052.svg": 855001,
	"./CustomIcon/QweatherIcons/1053.svg": 541411,
	"./CustomIcon/QweatherIcons/1054.svg": 332012,
	"./CustomIcon/QweatherIcons/1055.svg": 255473,
	"./CustomIcon/QweatherIcons/1056.svg": 185472,
	"./CustomIcon/QweatherIcons/1057.svg": 383086,
	"./CustomIcon/QweatherIcons/1058.svg": 945505,
	"./CustomIcon/QweatherIcons/1059.svg": 246975,
	"./CustomIcon/QweatherIcons/1061.svg": 743867,
	"./CustomIcon/QweatherIcons/1064.svg": 165908,
	"./CustomIcon/QweatherIcons/1101.svg": 848379,
	"./CustomIcon/QweatherIcons/1302.svg": 985363,
	"./CustomIcon/QweatherIcons/1402.svg": 716620,
	"./CustomIcon/QweatherIcons/150-fill.svg": 209178,
	"./CustomIcon/QweatherIcons/150.svg": 498125,
	"./CustomIcon/QweatherIcons/151-fill.svg": 442108,
	"./CustomIcon/QweatherIcons/151.svg": 916803,
	"./CustomIcon/QweatherIcons/152-fill.svg": 274287,
	"./CustomIcon/QweatherIcons/152.svg": 674171,
	"./CustomIcon/QweatherIcons/153-fill.svg": 565875,
	"./CustomIcon/QweatherIcons/153.svg": 889848,
	"./CustomIcon/QweatherIcons/1601.svg": 695350,
	"./CustomIcon/QweatherIcons/1602.svg": 795628,
	"./CustomIcon/QweatherIcons/1603.svg": 5453,
	"./CustomIcon/QweatherIcons/1604.svg": 697856,
	"./CustomIcon/QweatherIcons/1605.svg": 318411,
	"./CustomIcon/QweatherIcons/1606.svg": 115137,
	"./CustomIcon/QweatherIcons/1607.svg": 325826,
	"./CustomIcon/QweatherIcons/2001.svg": 986032,
	"./CustomIcon/QweatherIcons/2002.svg": 811349,
	"./CustomIcon/QweatherIcons/2003.svg": 520497,
	"./CustomIcon/QweatherIcons/2004.svg": 961588,
	"./CustomIcon/QweatherIcons/2005.svg": 937912,
	"./CustomIcon/QweatherIcons/2006.svg": 461888,
	"./CustomIcon/QweatherIcons/2007.svg": 685940,
	"./CustomIcon/QweatherIcons/2008.svg": 302831,
	"./CustomIcon/QweatherIcons/2009.svg": 771738,
	"./CustomIcon/QweatherIcons/2010.svg": 255648,
	"./CustomIcon/QweatherIcons/2011.svg": 622592,
	"./CustomIcon/QweatherIcons/2012.svg": 548679,
	"./CustomIcon/QweatherIcons/2013.svg": 434148,
	"./CustomIcon/QweatherIcons/2014.svg": 225068,
	"./CustomIcon/QweatherIcons/2015.svg": 157127,
	"./CustomIcon/QweatherIcons/2016.svg": 754024,
	"./CustomIcon/QweatherIcons/2017.svg": 276503,
	"./CustomIcon/QweatherIcons/2018.svg": 99722,
	"./CustomIcon/QweatherIcons/2019.svg": 266214,
	"./CustomIcon/QweatherIcons/2020.svg": 293173,
	"./CustomIcon/QweatherIcons/2021.svg": 550076,
	"./CustomIcon/QweatherIcons/2022.svg": 795258,
	"./CustomIcon/QweatherIcons/2023.svg": 273494,
	"./CustomIcon/QweatherIcons/2024.svg": 244770,
	"./CustomIcon/QweatherIcons/2025.svg": 454654,
	"./CustomIcon/QweatherIcons/2026.svg": 208882,
	"./CustomIcon/QweatherIcons/2027.svg": 907299,
	"./CustomIcon/QweatherIcons/2028.svg": 140753,
	"./CustomIcon/QweatherIcons/300-fill.svg": 102135,
	"./CustomIcon/QweatherIcons/300.svg": 692468,
	"./CustomIcon/QweatherIcons/301-fill.svg": 177463,
	"./CustomIcon/QweatherIcons/301.svg": 574615,
	"./CustomIcon/QweatherIcons/302-fill.svg": 101984,
	"./CustomIcon/QweatherIcons/302.svg": 874894,
	"./CustomIcon/QweatherIcons/303-fill.svg": 216903,
	"./CustomIcon/QweatherIcons/303.svg": 372157,
	"./CustomIcon/QweatherIcons/304-fill.svg": 174878,
	"./CustomIcon/QweatherIcons/304.svg": 729354,
	"./CustomIcon/QweatherIcons/305-fill.svg": 515965,
	"./CustomIcon/QweatherIcons/305.svg": 36383,
	"./CustomIcon/QweatherIcons/306-fill.svg": 783968,
	"./CustomIcon/QweatherIcons/306.svg": 799619,
	"./CustomIcon/QweatherIcons/307-fill.svg": 973658,
	"./CustomIcon/QweatherIcons/307.svg": 300233,
	"./CustomIcon/QweatherIcons/308-fill.svg": 175935,
	"./CustomIcon/QweatherIcons/308.svg": 60513,
	"./CustomIcon/QweatherIcons/309-fill.svg": 570500,
	"./CustomIcon/QweatherIcons/309.svg": 579237,
	"./CustomIcon/QweatherIcons/310-fill.svg": 76640,
	"./CustomIcon/QweatherIcons/310.svg": 243793,
	"./CustomIcon/QweatherIcons/311-fill.svg": 748790,
	"./CustomIcon/QweatherIcons/311.svg": 312061,
	"./CustomIcon/QweatherIcons/312-fill.svg": 401379,
	"./CustomIcon/QweatherIcons/312.svg": 44993,
	"./CustomIcon/QweatherIcons/313-fill.svg": 519708,
	"./CustomIcon/QweatherIcons/313.svg": 287841,
	"./CustomIcon/QweatherIcons/314-fill.svg": 446535,
	"./CustomIcon/QweatherIcons/314.svg": 664768,
	"./CustomIcon/QweatherIcons/315-fill.svg": 822544,
	"./CustomIcon/QweatherIcons/315.svg": 829916,
	"./CustomIcon/QweatherIcons/316-fill.svg": 389759,
	"./CustomIcon/QweatherIcons/316.svg": 209086,
	"./CustomIcon/QweatherIcons/317-fill.svg": 748248,
	"./CustomIcon/QweatherIcons/317.svg": 707062,
	"./CustomIcon/QweatherIcons/318-fill.svg": 108044,
	"./CustomIcon/QweatherIcons/318.svg": 958330,
	"./CustomIcon/QweatherIcons/350-fill.svg": 170312,
	"./CustomIcon/QweatherIcons/350.svg": 511477,
	"./CustomIcon/QweatherIcons/351-fill.svg": 906581,
	"./CustomIcon/QweatherIcons/351.svg": 45838,
	"./CustomIcon/QweatherIcons/399-fill.svg": 451202,
	"./CustomIcon/QweatherIcons/399.svg": 979719,
	"./CustomIcon/QweatherIcons/400-fill.svg": 324931,
	"./CustomIcon/QweatherIcons/400.svg": 732008,
	"./CustomIcon/QweatherIcons/401-fill.svg": 570758,
	"./CustomIcon/QweatherIcons/401.svg": 875171,
	"./CustomIcon/QweatherIcons/402-fill.svg": 402844,
	"./CustomIcon/QweatherIcons/402.svg": 451907,
	"./CustomIcon/QweatherIcons/403-fill.svg": 53049,
	"./CustomIcon/QweatherIcons/403.svg": 77113,
	"./CustomIcon/QweatherIcons/404-fill.svg": 526970,
	"./CustomIcon/QweatherIcons/404.svg": 392784,
	"./CustomIcon/QweatherIcons/405-fill.svg": 246568,
	"./CustomIcon/QweatherIcons/405.svg": 929197,
	"./CustomIcon/QweatherIcons/406-fill.svg": 145642,
	"./CustomIcon/QweatherIcons/406.svg": 911092,
	"./CustomIcon/QweatherIcons/407-fill.svg": 918674,
	"./CustomIcon/QweatherIcons/407.svg": 236316,
	"./CustomIcon/QweatherIcons/408-fill.svg": 56009,
	"./CustomIcon/QweatherIcons/408.svg": 80421,
	"./CustomIcon/QweatherIcons/409-fill.svg": 816119,
	"./CustomIcon/QweatherIcons/409.svg": 437975,
	"./CustomIcon/QweatherIcons/410-fill.svg": 311878,
	"./CustomIcon/QweatherIcons/410.svg": 167777,
	"./CustomIcon/QweatherIcons/456-fill.svg": 28431,
	"./CustomIcon/QweatherIcons/456.svg": 444390,
	"./CustomIcon/QweatherIcons/457-fill.svg": 955449,
	"./CustomIcon/QweatherIcons/457.svg": 977535,
	"./CustomIcon/QweatherIcons/499-fill.svg": 814693,
	"./CustomIcon/QweatherIcons/499.svg": 109703,
	"./CustomIcon/QweatherIcons/500-fill.svg": 495931,
	"./CustomIcon/QweatherIcons/500.svg": 96467,
	"./CustomIcon/QweatherIcons/501-fill.svg": 852184,
	"./CustomIcon/QweatherIcons/501.svg": 443962,
	"./CustomIcon/QweatherIcons/502-fill.svg": 591192,
	"./CustomIcon/QweatherIcons/502.svg": 93765,
	"./CustomIcon/QweatherIcons/503-fill.svg": 806343,
	"./CustomIcon/QweatherIcons/503.svg": 665662,
	"./CustomIcon/QweatherIcons/504-fill.svg": 714442,
	"./CustomIcon/QweatherIcons/504.svg": 772293,
	"./CustomIcon/QweatherIcons/507-fill.svg": 954310,
	"./CustomIcon/QweatherIcons/507.svg": 504840,
	"./CustomIcon/QweatherIcons/508-fill.svg": 593927,
	"./CustomIcon/QweatherIcons/508.svg": 418412,
	"./CustomIcon/QweatherIcons/509-fill.svg": 366712,
	"./CustomIcon/QweatherIcons/509.svg": 388375,
	"./CustomIcon/QweatherIcons/510-fill.svg": 366384,
	"./CustomIcon/QweatherIcons/510.svg": 285175,
	"./CustomIcon/QweatherIcons/511-fill.svg": 662286,
	"./CustomIcon/QweatherIcons/511.svg": 89889,
	"./CustomIcon/QweatherIcons/512-fill.svg": 265337,
	"./CustomIcon/QweatherIcons/512.svg": 25972,
	"./CustomIcon/QweatherIcons/513-fill.svg": 839970,
	"./CustomIcon/QweatherIcons/513.svg": 911351,
	"./CustomIcon/QweatherIcons/514-fill.svg": 847932,
	"./CustomIcon/QweatherIcons/514.svg": 308138,
	"./CustomIcon/QweatherIcons/515-fill.svg": 414897,
	"./CustomIcon/QweatherIcons/515.svg": 581733,
	"./CustomIcon/QweatherIcons/800.svg": 790478,
	"./CustomIcon/QweatherIcons/801.svg": 594546,
	"./CustomIcon/QweatherIcons/802.svg": 328387,
	"./CustomIcon/QweatherIcons/803.svg": 690064,
	"./CustomIcon/QweatherIcons/804.svg": 598337,
	"./CustomIcon/QweatherIcons/805.svg": 352800,
	"./CustomIcon/QweatherIcons/806.svg": 48089,
	"./CustomIcon/QweatherIcons/807.svg": 116187,
	"./CustomIcon/QweatherIcons/900-fill.svg": 538309,
	"./CustomIcon/QweatherIcons/900.svg": 242523,
	"./CustomIcon/QweatherIcons/901-fill.svg": 541730,
	"./CustomIcon/QweatherIcons/901.svg": 250999,
	"./CustomIcon/QweatherIcons/999-fill.svg": 2224,
	"./CustomIcon/QweatherIcons/999.svg": 461597,
	"./CustomIcon/QweatherIcons/9998.svg": 847778,
	"./CustomIcon/QweatherIcons/9999.svg": 770032,
	"./CustomIcon/acceptance.svg": 503971,
	"./CustomIcon/acceptance_img.svg": 335782,
	"./CustomIcon/acceptance_select_img.svg": 2101,
	"./CustomIcon/bdmoney.svg": 233170,
	"./CustomIcon/board.svg": 607764,
	"./CustomIcon/dynamicMonitoring/icon_GZCSQ.svg": 528986,
	"./CustomIcon/dynamicMonitoring/icon_KSSTXF.svg": 318139,
	"./CustomIcon/dynamicMonitoring/icon_QYZHZZ.svg": 243073,
	"./CustomIcon/dynamicMonitoring/icon_SSLTHCS.svg": 143197,
	"./CustomIcon/dynamicMonitoring/icon_TDFK.svg": 17736,
	"./CustomIcon/dynamicMonitoring/icon_area.svg": 958578,
	"./CustomIcon/dynamicMonitoring/icon_distance.svg": 348533,
	"./CustomIcon/dynamicMonitoring/icon_swipe.svg": 449778,
	"./CustomIcon/export.svg": 90036,
	"./CustomIcon/filing.svg": 447306,
	"./CustomIcon/filing_img.svg": 711020,
	"./CustomIcon/filing_select_img.svg": 157259,
	"./CustomIcon/hektare.svg": 576642,
	"./CustomIcon/icon-bdmoney.svg": 26152,
	"./CustomIcon/icon-export.svg": 848711,
	"./CustomIcon/icon-landArea.svg": 228367,
	"./CustomIcon/icon_back.svg": 622782,
	"./CustomIcon/icon_download.svg": 686518,
	"./CustomIcon/icon_folder.svg": 274060,
	"./CustomIcon/icon_upload.svg": 5414,
	"./CustomIcon/implement.svg": 810192,
	"./CustomIcon/implement_img.svg": 796021,
	"./CustomIcon/implement_select_img.svg": 791794,
	"./CustomIcon/landArea.svg": 13757,
	"./CustomIcon/list.svg": 650023,
	"./CustomIcon/mine.svg": 779852,
	"./CustomIcon/money.svg": 792526,
	"./CustomIcon/more-color.svg": 576952,
	"./CustomIcon/overdue.svg": 746770,
	"./CustomIcon/overdue_img.svg": 15119,
	"./CustomIcon/overdue_select_img.svg": 909266,
	"./CustomIcon/pigeonhole.svg": 70148,
	"./CustomIcon/pigeonhole_img.svg": 959844,
	"./CustomIcon/pigeonhole_select_img.svg": 470707,
	"./CustomIcon/production_area.svg": 373778,
	"./CustomIcon/production_location.svg": 975774,
	"./CustomIcon/production_mine.svg": 867186,
	"./CustomIcon/step/icon_acceptance.svg": 368454,
	"./CustomIcon/step/icon_acceptance_default.svg": 772677,
	"./CustomIcon/step/icon_acceptance_select.svg": 647207,
	"./CustomIcon/step/icon_archive.svg": 613955,
	"./CustomIcon/step/icon_archive_default.svg": 14517,
	"./CustomIcon/step/icon_archive_select.svg": 442549,
	"./CustomIcon/step/icon_implement.svg": 812174,
	"./CustomIcon/step/icon_implement_default.svg": 705883,
	"./CustomIcon/step/icon_implement_select.svg": 434112,
	"./CustomIcon/step/icon_plan.svg": 919602,
	"./CustomIcon/step/icon_plan_default.svg": 744873,
	"./CustomIcon/step/icon_plan_select.svg": 42737,
	"./CustomIcon/visualScreen.svg": 962621,
	"./Picture/duobianxing.svg": 63886,
	"./Picture/juxing.svg": 903319,
	"./RemixIcon/Buildings/ancient-gate-fill.svg": 623406,
	"./RemixIcon/Buildings/ancient-gate-line.svg": 369233,
	"./RemixIcon/Buildings/ancient-pavilion-fill.svg": 395102,
	"./RemixIcon/Buildings/ancient-pavilion-line.svg": 265862,
	"./RemixIcon/Buildings/bank-fill.svg": 724064,
	"./RemixIcon/Buildings/bank-line.svg": 884880,
	"./RemixIcon/Buildings/building-2-fill.svg": 365039,
	"./RemixIcon/Buildings/building-2-line.svg": 581726,
	"./RemixIcon/Buildings/building-3-fill.svg": 267122,
	"./RemixIcon/Buildings/building-3-line.svg": 128144,
	"./RemixIcon/Buildings/building-4-fill.svg": 574622,
	"./RemixIcon/Buildings/building-4-line.svg": 88106,
	"./RemixIcon/Buildings/building-fill.svg": 278063,
	"./RemixIcon/Buildings/building-line.svg": 547598,
	"./RemixIcon/Buildings/community-fill.svg": 822087,
	"./RemixIcon/Buildings/community-line.svg": 647369,
	"./RemixIcon/Buildings/government-fill.svg": 133745,
	"./RemixIcon/Buildings/government-line.svg": 373136,
	"./RemixIcon/Buildings/home-2-fill.svg": 547130,
	"./RemixIcon/Buildings/home-2-line.svg": 60242,
	"./RemixIcon/Buildings/home-3-fill.svg": 831501,
	"./RemixIcon/Buildings/home-3-line.svg": 478492,
	"./RemixIcon/Buildings/home-4-fill.svg": 79572,
	"./RemixIcon/Buildings/home-4-line.svg": 668592,
	"./RemixIcon/Buildings/home-5-fill.svg": 903853,
	"./RemixIcon/Buildings/home-5-line.svg": 260564,
	"./RemixIcon/Buildings/home-6-fill.svg": 423956,
	"./RemixIcon/Buildings/home-6-line.svg": 489151,
	"./RemixIcon/Buildings/home-7-fill.svg": 661378,
	"./RemixIcon/Buildings/home-7-line.svg": 401594,
	"./RemixIcon/Buildings/home-8-fill.svg": 868050,
	"./RemixIcon/Buildings/home-8-line.svg": 808697,
	"./RemixIcon/Buildings/home-fill.svg": 412405,
	"./RemixIcon/Buildings/home-gear-fill.svg": 447449,
	"./RemixIcon/Buildings/home-gear-line.svg": 672615,
	"./RemixIcon/Buildings/home-heart-fill.svg": 262080,
	"./RemixIcon/Buildings/home-heart-line.svg": 739039,
	"./RemixIcon/Buildings/home-line.svg": 328231,
	"./RemixIcon/Buildings/home-smile-2-fill.svg": 639576,
	"./RemixIcon/Buildings/home-smile-2-line.svg": 73711,
	"./RemixIcon/Buildings/home-smile-fill.svg": 834882,
	"./RemixIcon/Buildings/home-smile-line.svg": 345505,
	"./RemixIcon/Buildings/home-wifi-fill.svg": 415874,
	"./RemixIcon/Buildings/home-wifi-line.svg": 59981,
	"./RemixIcon/Buildings/hospital-fill.svg": 549500,
	"./RemixIcon/Buildings/hospital-line.svg": 736314,
	"./RemixIcon/Buildings/hotel-fill.svg": 231978,
	"./RemixIcon/Buildings/hotel-line.svg": 255146,
	"./RemixIcon/Buildings/store-2-fill.svg": 487056,
	"./RemixIcon/Buildings/store-2-line.svg": 705675,
	"./RemixIcon/Buildings/store-3-fill.svg": 16033,
	"./RemixIcon/Buildings/store-3-line.svg": 764327,
	"./RemixIcon/Buildings/store-fill.svg": 1896,
	"./RemixIcon/Buildings/store-line.svg": 183262,
	"./RemixIcon/Business/advertisement-fill.svg": 710299,
	"./RemixIcon/Business/advertisement-line.svg": 144295,
	"./RemixIcon/Business/archive-drawer-fill.svg": 802732,
	"./RemixIcon/Business/archive-drawer-line.svg": 109625,
	"./RemixIcon/Business/archive-fill.svg": 765612,
	"./RemixIcon/Business/archive-line.svg": 643119,
	"./RemixIcon/Business/at-fill.svg": 527040,
	"./RemixIcon/Business/at-line.svg": 627042,
	"./RemixIcon/Business/attachment-fill.svg": 750163,
	"./RemixIcon/Business/attachment-line.svg": 310762,
	"./RemixIcon/Business/award-fill.svg": 191821,
	"./RemixIcon/Business/award-line.svg": 929620,
	"./RemixIcon/Business/bar-chart-2-fill.svg": 684428,
	"./RemixIcon/Business/bar-chart-2-line.svg": 191349,
	"./RemixIcon/Business/bar-chart-box-fill.svg": 534889,
	"./RemixIcon/Business/bar-chart-box-line.svg": 80394,
	"./RemixIcon/Business/bar-chart-fill.svg": 83742,
	"./RemixIcon/Business/bar-chart-grouped-fill.svg": 247756,
	"./RemixIcon/Business/bar-chart-grouped-line.svg": 151835,
	"./RemixIcon/Business/bar-chart-horizontal-fill.svg": 566482,
	"./RemixIcon/Business/bar-chart-horizontal-line.svg": 306160,
	"./RemixIcon/Business/bar-chart-line.svg": 454073,
	"./RemixIcon/Business/bookmark-2-fill.svg": 259129,
	"./RemixIcon/Business/bookmark-2-line.svg": 374334,
	"./RemixIcon/Business/bookmark-3-fill.svg": 134127,
	"./RemixIcon/Business/bookmark-3-line.svg": 37965,
	"./RemixIcon/Business/bookmark-fill.svg": 384620,
	"./RemixIcon/Business/bookmark-line.svg": 444919,
	"./RemixIcon/Business/briefcase-2-fill.svg": 652106,
	"./RemixIcon/Business/briefcase-2-line.svg": 658811,
	"./RemixIcon/Business/briefcase-3-fill.svg": 748587,
	"./RemixIcon/Business/briefcase-3-line.svg": 642647,
	"./RemixIcon/Business/briefcase-4-fill.svg": 301300,
	"./RemixIcon/Business/briefcase-4-line.svg": 575623,
	"./RemixIcon/Business/briefcase-5-fill.svg": 638136,
	"./RemixIcon/Business/briefcase-5-line.svg": 92885,
	"./RemixIcon/Business/briefcase-fill.svg": 562917,
	"./RemixIcon/Business/briefcase-line.svg": 859950,
	"./RemixIcon/Business/bubble-chart-fill.svg": 856538,
	"./RemixIcon/Business/bubble-chart-line.svg": 353992,
	"./RemixIcon/Business/calculator-fill.svg": 318694,
	"./RemixIcon/Business/calculator-line.svg": 535055,
	"./RemixIcon/Business/calendar-2-fill.svg": 953752,
	"./RemixIcon/Business/calendar-2-line.svg": 22017,
	"./RemixIcon/Business/calendar-check-fill.svg": 215282,
	"./RemixIcon/Business/calendar-check-line.svg": 587886,
	"./RemixIcon/Business/calendar-event-fill.svg": 304978,
	"./RemixIcon/Business/calendar-event-line.svg": 188201,
	"./RemixIcon/Business/calendar-fill.svg": 594569,
	"./RemixIcon/Business/calendar-line.svg": 944413,
	"./RemixIcon/Business/calendar-todo-fill.svg": 979645,
	"./RemixIcon/Business/calendar-todo-line.svg": 465133,
	"./RemixIcon/Business/cloud-fill.svg": 373044,
	"./RemixIcon/Business/cloud-line.svg": 109883,
	"./RemixIcon/Business/cloud-off-fill.svg": 498537,
	"./RemixIcon/Business/cloud-off-line.svg": 146479,
	"./RemixIcon/Business/copyleft-fill.svg": 804723,
	"./RemixIcon/Business/copyleft-line.svg": 664171,
	"./RemixIcon/Business/copyright-fill.svg": 19489,
	"./RemixIcon/Business/copyright-line.svg": 818567,
	"./RemixIcon/Business/creative-commons-by-fill.svg": 944593,
	"./RemixIcon/Business/creative-commons-by-line.svg": 648950,
	"./RemixIcon/Business/creative-commons-fill.svg": 622472,
	"./RemixIcon/Business/creative-commons-line.svg": 186570,
	"./RemixIcon/Business/creative-commons-nc-fill.svg": 917161,
	"./RemixIcon/Business/creative-commons-nc-line.svg": 982043,
	"./RemixIcon/Business/creative-commons-nd-fill.svg": 300462,
	"./RemixIcon/Business/creative-commons-nd-line.svg": 835304,
	"./RemixIcon/Business/creative-commons-sa-fill.svg": 833336,
	"./RemixIcon/Business/creative-commons-sa-line.svg": 546714,
	"./RemixIcon/Business/creative-commons-zero-fill.svg": 812701,
	"./RemixIcon/Business/creative-commons-zero-line.svg": 393818,
	"./RemixIcon/Business/customer-service-2-fill.svg": 329894,
	"./RemixIcon/Business/customer-service-2-line.svg": 166529,
	"./RemixIcon/Business/customer-service-fill.svg": 224593,
	"./RemixIcon/Business/customer-service-line.svg": 76321,
	"./RemixIcon/Business/donut-chart-fill.svg": 21523,
	"./RemixIcon/Business/donut-chart-line.svg": 220207,
	"./RemixIcon/Business/flag-2-fill.svg": 988799,
	"./RemixIcon/Business/flag-2-line.svg": 598609,
	"./RemixIcon/Business/flag-fill.svg": 613137,
	"./RemixIcon/Business/flag-line.svg": 374799,
	"./RemixIcon/Business/global-fill.svg": 199785,
	"./RemixIcon/Business/global-line.svg": 985582,
	"./RemixIcon/Business/honour-fill.svg": 524281,
	"./RemixIcon/Business/honour-line.svg": 474832,
	"./RemixIcon/Business/inbox-archive-fill.svg": 598459,
	"./RemixIcon/Business/inbox-archive-line.svg": 204757,
	"./RemixIcon/Business/inbox-fill.svg": 260452,
	"./RemixIcon/Business/inbox-line.svg": 161961,
	"./RemixIcon/Business/inbox-unarchive-fill.svg": 151440,
	"./RemixIcon/Business/inbox-unarchive-line.svg": 756079,
	"./RemixIcon/Business/line-chart-fill.svg": 327279,
	"./RemixIcon/Business/line-chart-line.svg": 714932,
	"./RemixIcon/Business/links-fill.svg": 343801,
	"./RemixIcon/Business/links-line.svg": 446625,
	"./RemixIcon/Business/mail-add-fill.svg": 583257,
	"./RemixIcon/Business/mail-add-line.svg": 714675,
	"./RemixIcon/Business/mail-check-fill.svg": 626476,
	"./RemixIcon/Business/mail-check-line.svg": 219283,
	"./RemixIcon/Business/mail-close-fill.svg": 203938,
	"./RemixIcon/Business/mail-close-line.svg": 887214,
	"./RemixIcon/Business/mail-download-fill.svg": 94039,
	"./RemixIcon/Business/mail-download-line.svg": 789047,
	"./RemixIcon/Business/mail-fill.svg": 889278,
	"./RemixIcon/Business/mail-forbid-fill.svg": 468198,
	"./RemixIcon/Business/mail-forbid-line.svg": 929513,
	"./RemixIcon/Business/mail-line.svg": 671199,
	"./RemixIcon/Business/mail-lock-fill.svg": 644233,
	"./RemixIcon/Business/mail-lock-line.svg": 64500,
	"./RemixIcon/Business/mail-open-fill.svg": 200055,
	"./RemixIcon/Business/mail-open-line.svg": 181251,
	"./RemixIcon/Business/mail-send-fill.svg": 519283,
	"./RemixIcon/Business/mail-send-line.svg": 108474,
	"./RemixIcon/Business/mail-settings-fill.svg": 810397,
	"./RemixIcon/Business/mail-settings-line.svg": 507710,
	"./RemixIcon/Business/mail-star-fill.svg": 717956,
	"./RemixIcon/Business/mail-star-line.svg": 946016,
	"./RemixIcon/Business/mail-unread-fill.svg": 257130,
	"./RemixIcon/Business/mail-unread-line.svg": 437642,
	"./RemixIcon/Business/mail-volume-fill.svg": 888542,
	"./RemixIcon/Business/mail-volume-line.svg": 957955,
	"./RemixIcon/Business/medal-2-fill.svg": 158655,
	"./RemixIcon/Business/medal-2-line.svg": 542756,
	"./RemixIcon/Business/medal-fill.svg": 601051,
	"./RemixIcon/Business/medal-line.svg": 948634,
	"./RemixIcon/Business/pie-chart-2-fill.svg": 910406,
	"./RemixIcon/Business/pie-chart-2-line.svg": 760855,
	"./RemixIcon/Business/pie-chart-box-fill.svg": 739609,
	"./RemixIcon/Business/pie-chart-box-line.svg": 33289,
	"./RemixIcon/Business/pie-chart-fill.svg": 865407,
	"./RemixIcon/Business/pie-chart-line.svg": 666045,
	"./RemixIcon/Business/printer-cloud-fill.svg": 509848,
	"./RemixIcon/Business/printer-cloud-line.svg": 305075,
	"./RemixIcon/Business/printer-fill.svg": 437868,
	"./RemixIcon/Business/printer-line.svg": 414445,
	"./RemixIcon/Business/profile-fill.svg": 498708,
	"./RemixIcon/Business/profile-line.svg": 144157,
	"./RemixIcon/Business/projector-2-fill.svg": 745730,
	"./RemixIcon/Business/projector-2-line.svg": 793729,
	"./RemixIcon/Business/projector-fill.svg": 326603,
	"./RemixIcon/Business/projector-line.svg": 498443,
	"./RemixIcon/Business/record-mail-fill.svg": 137822,
	"./RemixIcon/Business/record-mail-line.svg": 578674,
	"./RemixIcon/Business/registered-fill.svg": 860874,
	"./RemixIcon/Business/registered-line.svg": 173786,
	"./RemixIcon/Business/reply-all-fill.svg": 431129,
	"./RemixIcon/Business/reply-all-line.svg": 647540,
	"./RemixIcon/Business/reply-fill.svg": 551597,
	"./RemixIcon/Business/reply-line.svg": 386314,
	"./RemixIcon/Business/send-plane-2-fill.svg": 154305,
	"./RemixIcon/Business/send-plane-2-line.svg": 936096,
	"./RemixIcon/Business/send-plane-fill.svg": 471969,
	"./RemixIcon/Business/send-plane-line.svg": 596193,
	"./RemixIcon/Business/service-fill.svg": 944588,
	"./RemixIcon/Business/service-line.svg": 696549,
	"./RemixIcon/Business/slideshow-2-fill.svg": 258414,
	"./RemixIcon/Business/slideshow-2-line.svg": 644523,
	"./RemixIcon/Business/slideshow-3-fill.svg": 633232,
	"./RemixIcon/Business/slideshow-3-line.svg": 42658,
	"./RemixIcon/Business/slideshow-4-fill.svg": 292578,
	"./RemixIcon/Business/slideshow-4-line.svg": 624195,
	"./RemixIcon/Business/slideshow-fill.svg": 379475,
	"./RemixIcon/Business/slideshow-line.svg": 741917,
	"./RemixIcon/Business/stack-fill.svg": 453570,
	"./RemixIcon/Business/stack-line.svg": 706798,
	"./RemixIcon/Business/trademark-fill.svg": 15790,
	"./RemixIcon/Business/trademark-line.svg": 908007,
	"./RemixIcon/Business/window-2-fill.svg": 444999,
	"./RemixIcon/Business/window-2-line.svg": 84699,
	"./RemixIcon/Business/window-fill.svg": 631279,
	"./RemixIcon/Business/window-line.svg": 789679,
	"./RemixIcon/Communication/chat-1-fill.svg": 946923,
	"./RemixIcon/Communication/chat-1-line.svg": 100288,
	"./RemixIcon/Communication/chat-2-fill.svg": 70056,
	"./RemixIcon/Communication/chat-2-line.svg": 40499,
	"./RemixIcon/Communication/chat-3-fill.svg": 767227,
	"./RemixIcon/Communication/chat-3-line.svg": 311377,
	"./RemixIcon/Communication/chat-4-fill.svg": 531830,
	"./RemixIcon/Communication/chat-4-line.svg": 161555,
	"./RemixIcon/Communication/chat-check-fill.svg": 211977,
	"./RemixIcon/Communication/chat-check-line.svg": 606269,
	"./RemixIcon/Communication/chat-delete-fill.svg": 535834,
	"./RemixIcon/Communication/chat-delete-line.svg": 278880,
	"./RemixIcon/Communication/chat-download-fill.svg": 675519,
	"./RemixIcon/Communication/chat-download-line.svg": 232995,
	"./RemixIcon/Communication/chat-follow-up-fill.svg": 247807,
	"./RemixIcon/Communication/chat-follow-up-line.svg": 850333,
	"./RemixIcon/Communication/chat-forward-fill.svg": 593069,
	"./RemixIcon/Communication/chat-forward-line.svg": 893359,
	"./RemixIcon/Communication/chat-heart-fill.svg": 51465,
	"./RemixIcon/Communication/chat-heart-line.svg": 532240,
	"./RemixIcon/Communication/chat-history-fill.svg": 93953,
	"./RemixIcon/Communication/chat-history-line.svg": 663223,
	"./RemixIcon/Communication/chat-new-fill.svg": 819096,
	"./RemixIcon/Communication/chat-new-line.svg": 672835,
	"./RemixIcon/Communication/chat-off-fill.svg": 412078,
	"./RemixIcon/Communication/chat-off-line.svg": 972267,
	"./RemixIcon/Communication/chat-poll-fill.svg": 692745,
	"./RemixIcon/Communication/chat-poll-line.svg": 567900,
	"./RemixIcon/Communication/chat-private-fill.svg": 555095,
	"./RemixIcon/Communication/chat-private-line.svg": 273379,
	"./RemixIcon/Communication/chat-quote-fill.svg": 792403,
	"./RemixIcon/Communication/chat-quote-line.svg": 864887,
	"./RemixIcon/Communication/chat-settings-fill.svg": 818575,
	"./RemixIcon/Communication/chat-settings-line.svg": 224744,
	"./RemixIcon/Communication/chat-smile-2-fill.svg": 876823,
	"./RemixIcon/Communication/chat-smile-2-line.svg": 39127,
	"./RemixIcon/Communication/chat-smile-3-fill.svg": 646578,
	"./RemixIcon/Communication/chat-smile-3-line.svg": 619297,
	"./RemixIcon/Communication/chat-smile-fill.svg": 599082,
	"./RemixIcon/Communication/chat-smile-line.svg": 91001,
	"./RemixIcon/Communication/chat-upload-fill.svg": 229231,
	"./RemixIcon/Communication/chat-upload-line.svg": 997734,
	"./RemixIcon/Communication/chat-voice-fill.svg": 795867,
	"./RemixIcon/Communication/chat-voice-line.svg": 770511,
	"./RemixIcon/Communication/discuss-fill.svg": 123602,
	"./RemixIcon/Communication/discuss-line.svg": 628806,
	"./RemixIcon/Communication/feedback-fill.svg": 157378,
	"./RemixIcon/Communication/feedback-line.svg": 689064,
	"./RemixIcon/Communication/message-2-fill.svg": 293049,
	"./RemixIcon/Communication/message-2-line.svg": 579397,
	"./RemixIcon/Communication/message-3-fill.svg": 676536,
	"./RemixIcon/Communication/message-3-line.svg": 806627,
	"./RemixIcon/Communication/message-fill.svg": 868471,
	"./RemixIcon/Communication/message-line.svg": 618571,
	"./RemixIcon/Communication/question-answer-fill.svg": 494203,
	"./RemixIcon/Communication/question-answer-line.svg": 10147,
	"./RemixIcon/Communication/questionnaire-fill.svg": 90302,
	"./RemixIcon/Communication/questionnaire-line.svg": 970481,
	"./RemixIcon/Communication/video-chat-fill.svg": 270468,
	"./RemixIcon/Communication/video-chat-line.svg": 790346,
	"./RemixIcon/Design/anticlockwise-2-fill.svg": 770409,
	"./RemixIcon/Design/anticlockwise-2-line.svg": 99574,
	"./RemixIcon/Design/anticlockwise-fill.svg": 249331,
	"./RemixIcon/Design/anticlockwise-line.svg": 27792,
	"./RemixIcon/Design/artboard-2-fill.svg": 653877,
	"./RemixIcon/Design/artboard-2-line.svg": 68795,
	"./RemixIcon/Design/artboard-fill.svg": 467331,
	"./RemixIcon/Design/artboard-line.svg": 515548,
	"./RemixIcon/Design/ball-pen-fill.svg": 938175,
	"./RemixIcon/Design/ball-pen-line.svg": 74104,
	"./RemixIcon/Design/blur-off-fill.svg": 395963,
	"./RemixIcon/Design/blur-off-line.svg": 926121,
	"./RemixIcon/Design/brush-2-fill.svg": 548919,
	"./RemixIcon/Design/brush-2-line.svg": 515529,
	"./RemixIcon/Design/brush-3-fill.svg": 546754,
	"./RemixIcon/Design/brush-3-line.svg": 707206,
	"./RemixIcon/Design/brush-4-fill.svg": 362735,
	"./RemixIcon/Design/brush-4-line.svg": 266551,
	"./RemixIcon/Design/brush-fill.svg": 513989,
	"./RemixIcon/Design/brush-line.svg": 638073,
	"./RemixIcon/Design/clockwise-2-fill.svg": 146882,
	"./RemixIcon/Design/clockwise-2-line.svg": 295454,
	"./RemixIcon/Design/clockwise-fill.svg": 769965,
	"./RemixIcon/Design/clockwise-line.svg": 955923,
	"./RemixIcon/Design/collage-fill.svg": 565511,
	"./RemixIcon/Design/collage-line.svg": 139619,
	"./RemixIcon/Design/compasses-2-fill.svg": 996257,
	"./RemixIcon/Design/compasses-2-line.svg": 913568,
	"./RemixIcon/Design/compasses-fill.svg": 201640,
	"./RemixIcon/Design/compasses-line.svg": 166088,
	"./RemixIcon/Design/contrast-2-fill.svg": 851770,
	"./RemixIcon/Design/contrast-2-line.svg": 297078,
	"./RemixIcon/Design/contrast-drop-2-fill.svg": 85570,
	"./RemixIcon/Design/contrast-drop-2-line.svg": 460386,
	"./RemixIcon/Design/contrast-drop-fill.svg": 368046,
	"./RemixIcon/Design/contrast-drop-line.svg": 446798,
	"./RemixIcon/Design/contrast-fill.svg": 14030,
	"./RemixIcon/Design/contrast-line.svg": 878329,
	"./RemixIcon/Design/crop-2-fill.svg": 132269,
	"./RemixIcon/Design/crop-2-line.svg": 220316,
	"./RemixIcon/Design/crop-fill.svg": 58554,
	"./RemixIcon/Design/crop-line.svg": 315348,
	"./RemixIcon/Design/drag-drop-fill.svg": 924845,
	"./RemixIcon/Design/drag-drop-line.svg": 879795,
	"./RemixIcon/Design/drag-move-2-fill.svg": 202034,
	"./RemixIcon/Design/drag-move-2-line.svg": 759901,
	"./RemixIcon/Design/drag-move-fill.svg": 313957,
	"./RemixIcon/Design/drag-move-line.svg": 577929,
	"./RemixIcon/Design/drop-fill.svg": 348511,
	"./RemixIcon/Design/drop-line.svg": 305334,
	"./RemixIcon/Design/edit-2-fill.svg": 86309,
	"./RemixIcon/Design/edit-2-line.svg": 835717,
	"./RemixIcon/Design/edit-box-fill.svg": 736918,
	"./RemixIcon/Design/edit-box-line.svg": 452624,
	"./RemixIcon/Design/edit-circle-fill.svg": 64806,
	"./RemixIcon/Design/edit-circle-line.svg": 466541,
	"./RemixIcon/Design/edit-fill.svg": 572146,
	"./RemixIcon/Design/edit-line.svg": 331079,
	"./RemixIcon/Design/eraser-fill.svg": 36754,
	"./RemixIcon/Design/eraser-line.svg": 639166,
	"./RemixIcon/Design/focus-2-fill.svg": 519304,
	"./RemixIcon/Design/focus-2-line.svg": 244584,
	"./RemixIcon/Design/focus-3-fill.svg": 536701,
	"./RemixIcon/Design/focus-3-line.svg": 169245,
	"./RemixIcon/Design/focus-fill.svg": 106444,
	"./RemixIcon/Design/focus-line.svg": 782950,
	"./RemixIcon/Design/grid-fill.svg": 68112,
	"./RemixIcon/Design/grid-line.svg": 716893,
	"./RemixIcon/Design/hammer-fill.svg": 120497,
	"./RemixIcon/Design/hammer-line.svg": 55458,
	"./RemixIcon/Design/ink-bottle-fill.svg": 847229,
	"./RemixIcon/Design/ink-bottle-line.svg": 274280,
	"./RemixIcon/Design/input-method-fill.svg": 399332,
	"./RemixIcon/Design/input-method-line.svg": 922197,
	"./RemixIcon/Design/layout-2-fill.svg": 554533,
	"./RemixIcon/Design/layout-2-line.svg": 372049,
	"./RemixIcon/Design/layout-3-fill.svg": 178369,
	"./RemixIcon/Design/layout-3-line.svg": 521271,
	"./RemixIcon/Design/layout-4-fill.svg": 537092,
	"./RemixIcon/Design/layout-4-line.svg": 375246,
	"./RemixIcon/Design/layout-5-fill.svg": 635753,
	"./RemixIcon/Design/layout-5-line.svg": 5380,
	"./RemixIcon/Design/layout-6-fill.svg": 332519,
	"./RemixIcon/Design/layout-6-line.svg": 847423,
	"./RemixIcon/Design/layout-bottom-2-fill.svg": 974592,
	"./RemixIcon/Design/layout-bottom-2-line.svg": 795898,
	"./RemixIcon/Design/layout-bottom-fill.svg": 716191,
	"./RemixIcon/Design/layout-bottom-line.svg": 973314,
	"./RemixIcon/Design/layout-column-fill.svg": 568599,
	"./RemixIcon/Design/layout-column-line.svg": 264283,
	"./RemixIcon/Design/layout-fill.svg": 681611,
	"./RemixIcon/Design/layout-grid-fill.svg": 971804,
	"./RemixIcon/Design/layout-grid-line.svg": 292546,
	"./RemixIcon/Design/layout-left-2-fill.svg": 11445,
	"./RemixIcon/Design/layout-left-2-line.svg": 260609,
	"./RemixIcon/Design/layout-left-fill.svg": 672591,
	"./RemixIcon/Design/layout-left-line.svg": 69669,
	"./RemixIcon/Design/layout-line.svg": 134228,
	"./RemixIcon/Design/layout-masonry-fill.svg": 135853,
	"./RemixIcon/Design/layout-masonry-line.svg": 532491,
	"./RemixIcon/Design/layout-right-2-fill.svg": 717294,
	"./RemixIcon/Design/layout-right-2-line.svg": 559760,
	"./RemixIcon/Design/layout-right-fill.svg": 176215,
	"./RemixIcon/Design/layout-right-line.svg": 417754,
	"./RemixIcon/Design/layout-row-fill.svg": 321391,
	"./RemixIcon/Design/layout-row-line.svg": 768727,
	"./RemixIcon/Design/layout-top-2-fill.svg": 848117,
	"./RemixIcon/Design/layout-top-2-line.svg": 547024,
	"./RemixIcon/Design/layout-top-fill.svg": 953562,
	"./RemixIcon/Design/layout-top-line.svg": 127267,
	"./RemixIcon/Design/magic-fill.svg": 952375,
	"./RemixIcon/Design/magic-line.svg": 195074,
	"./RemixIcon/Design/mark-pen-fill.svg": 758573,
	"./RemixIcon/Design/mark-pen-line.svg": 426083,
	"./RemixIcon/Design/markup-fill.svg": 84813,
	"./RemixIcon/Design/markup-line.svg": 597271,
	"./RemixIcon/Design/paint-brush-fill.svg": 181244,
	"./RemixIcon/Design/paint-brush-line.svg": 726145,
	"./RemixIcon/Design/paint-fill.svg": 163239,
	"./RemixIcon/Design/paint-line.svg": 558311,
	"./RemixIcon/Design/palette-fill.svg": 424742,
	"./RemixIcon/Design/palette-line.svg": 459221,
	"./RemixIcon/Design/pantone-fill.svg": 6153,
	"./RemixIcon/Design/pantone-line.svg": 635224,
	"./RemixIcon/Design/pen-nib-fill.svg": 761094,
	"./RemixIcon/Design/pen-nib-line.svg": 551184,
	"./RemixIcon/Design/pencil-fill.svg": 597581,
	"./RemixIcon/Design/pencil-line.svg": 454084,
	"./RemixIcon/Design/pencil-ruler-2-fill.svg": 133100,
	"./RemixIcon/Design/pencil-ruler-2-line.svg": 205789,
	"./RemixIcon/Design/pencil-ruler-fill.svg": 514600,
	"./RemixIcon/Design/pencil-ruler-line.svg": 309449,
	"./RemixIcon/Design/quill-pen-fill.svg": 648018,
	"./RemixIcon/Design/quill-pen-line.svg": 830538,
	"./RemixIcon/Design/ruler-2-fill.svg": 980448,
	"./RemixIcon/Design/ruler-2-line.svg": 283467,
	"./RemixIcon/Design/ruler-fill.svg": 481862,
	"./RemixIcon/Design/ruler-line.svg": 78628,
	"./RemixIcon/Design/scissors-2-fill.svg": 166207,
	"./RemixIcon/Design/scissors-2-line.svg": 427248,
	"./RemixIcon/Design/scissors-cut-fill.svg": 570176,
	"./RemixIcon/Design/scissors-cut-line.svg": 926270,
	"./RemixIcon/Design/scissors-fill.svg": 37002,
	"./RemixIcon/Design/scissors-line.svg": 56868,
	"./RemixIcon/Design/screenshot-2-fill.svg": 615549,
	"./RemixIcon/Design/screenshot-2-line.svg": 386157,
	"./RemixIcon/Design/screenshot-fill.svg": 760358,
	"./RemixIcon/Design/screenshot-line.svg": 289390,
	"./RemixIcon/Design/shape-2-fill.svg": 820049,
	"./RemixIcon/Design/shape-2-line.svg": 244325,
	"./RemixIcon/Design/shape-fill.svg": 134266,
	"./RemixIcon/Design/shape-line.svg": 519764,
	"./RemixIcon/Design/sip-fill.svg": 773009,
	"./RemixIcon/Design/sip-line.svg": 618254,
	"./RemixIcon/Design/slice-fill.svg": 407451,
	"./RemixIcon/Design/slice-line.svg": 614045,
	"./RemixIcon/Design/t-box-fill.svg": 694652,
	"./RemixIcon/Design/t-box-line.svg": 294619,
	"./RemixIcon/Design/table-alt-fill.svg": 614889,
	"./RemixIcon/Design/table-alt-line.svg": 317485,
	"./RemixIcon/Design/table-fill.svg": 136604,
	"./RemixIcon/Design/table-line.svg": 6114,
	"./RemixIcon/Design/tools-fill.svg": 525460,
	"./RemixIcon/Design/tools-line.svg": 368397,
	"./RemixIcon/Development/braces-fill.svg": 178921,
	"./RemixIcon/Development/braces-line.svg": 685540,
	"./RemixIcon/Development/brackets-fill.svg": 644236,
	"./RemixIcon/Development/brackets-line.svg": 797473,
	"./RemixIcon/Development/bug-2-fill.svg": 471251,
	"./RemixIcon/Development/bug-2-line.svg": 317713,
	"./RemixIcon/Development/bug-fill.svg": 830853,
	"./RemixIcon/Development/bug-line.svg": 893944,
	"./RemixIcon/Development/code-box-fill.svg": 353384,
	"./RemixIcon/Development/code-box-line.svg": 218941,
	"./RemixIcon/Development/code-fill.svg": 509878,
	"./RemixIcon/Development/code-line.svg": 837589,
	"./RemixIcon/Development/code-s-fill.svg": 648197,
	"./RemixIcon/Development/code-s-line.svg": 177985,
	"./RemixIcon/Development/code-s-slash-fill.svg": 359703,
	"./RemixIcon/Development/code-s-slash-line.svg": 376417,
	"./RemixIcon/Development/command-fill.svg": 146915,
	"./RemixIcon/Development/command-line.svg": 348837,
	"./RemixIcon/Development/css3-fill.svg": 544316,
	"./RemixIcon/Development/css3-line.svg": 784917,
	"./RemixIcon/Development/cursor-fill.svg": 704673,
	"./RemixIcon/Development/cursor-line.svg": 61455,
	"./RemixIcon/Development/git-branch-fill.svg": 43250,
	"./RemixIcon/Development/git-branch-line.svg": 536024,
	"./RemixIcon/Development/git-commit-fill.svg": 388853,
	"./RemixIcon/Development/git-commit-line.svg": 666096,
	"./RemixIcon/Development/git-merge-fill.svg": 919933,
	"./RemixIcon/Development/git-merge-line.svg": 326249,
	"./RemixIcon/Development/git-pull-request-fill.svg": 890424,
	"./RemixIcon/Development/git-pull-request-line.svg": 461717,
	"./RemixIcon/Development/git-repository-commits-fill.svg": 592713,
	"./RemixIcon/Development/git-repository-commits-line.svg": 395944,
	"./RemixIcon/Development/git-repository-fill.svg": 928506,
	"./RemixIcon/Development/git-repository-line.svg": 934894,
	"./RemixIcon/Development/git-repository-private-fill.svg": 985038,
	"./RemixIcon/Development/git-repository-private-line.svg": 999164,
	"./RemixIcon/Development/html5-fill.svg": 222292,
	"./RemixIcon/Development/html5-line.svg": 261383,
	"./RemixIcon/Development/parentheses-fill.svg": 70006,
	"./RemixIcon/Development/parentheses-line.svg": 289033,
	"./RemixIcon/Development/terminal-box-fill.svg": 542509,
	"./RemixIcon/Development/terminal-box-line.svg": 48227,
	"./RemixIcon/Development/terminal-fill.svg": 580978,
	"./RemixIcon/Development/terminal-line.svg": 51741,
	"./RemixIcon/Development/terminal-window-fill.svg": 731044,
	"./RemixIcon/Development/terminal-window-line.svg": 754125,
	"./RemixIcon/Device/airplay-fill.svg": 548242,
	"./RemixIcon/Device/airplay-line.svg": 275867,
	"./RemixIcon/Device/barcode-box-fill.svg": 794017,
	"./RemixIcon/Device/barcode-box-line.svg": 285571,
	"./RemixIcon/Device/barcode-fill.svg": 509934,
	"./RemixIcon/Device/barcode-line.svg": 646627,
	"./RemixIcon/Device/base-station-fill.svg": 140892,
	"./RemixIcon/Device/base-station-line.svg": 308811,
	"./RemixIcon/Device/battery-2-charge-fill.svg": 554059,
	"./RemixIcon/Device/battery-2-charge-line.svg": 748363,
	"./RemixIcon/Device/battery-2-fill.svg": 687783,
	"./RemixIcon/Device/battery-2-line.svg": 526263,
	"./RemixIcon/Device/battery-charge-fill.svg": 118327,
	"./RemixIcon/Device/battery-charge-line.svg": 223878,
	"./RemixIcon/Device/battery-fill.svg": 897587,
	"./RemixIcon/Device/battery-line.svg": 903345,
	"./RemixIcon/Device/battery-low-fill.svg": 794410,
	"./RemixIcon/Device/battery-low-line.svg": 443158,
	"./RemixIcon/Device/battery-saver-fill.svg": 316583,
	"./RemixIcon/Device/battery-saver-line.svg": 136975,
	"./RemixIcon/Device/battery-share-fill.svg": 913633,
	"./RemixIcon/Device/battery-share-line.svg": 900122,
	"./RemixIcon/Device/bluetooth-connect-fill.svg": 931549,
	"./RemixIcon/Device/bluetooth-connect-line.svg": 477410,
	"./RemixIcon/Device/bluetooth-fill.svg": 826296,
	"./RemixIcon/Device/bluetooth-line.svg": 32906,
	"./RemixIcon/Device/cast-fill.svg": 8053,
	"./RemixIcon/Device/cast-line.svg": 944692,
	"./RemixIcon/Device/cellphone-fill.svg": 317497,
	"./RemixIcon/Device/cellphone-line.svg": 401546,
	"./RemixIcon/Device/computer-fill.svg": 327996,
	"./RemixIcon/Device/computer-line.svg": 356417,
	"./RemixIcon/Device/cpu-fill.svg": 951919,
	"./RemixIcon/Device/cpu-line.svg": 34013,
	"./RemixIcon/Device/dashboard-2-fill.svg": 182494,
	"./RemixIcon/Device/dashboard-2-line.svg": 508624,
	"./RemixIcon/Device/dashboard-3-fill.svg": 522098,
	"./RemixIcon/Device/dashboard-3-line.svg": 770376,
	"./RemixIcon/Device/database-2-fill.svg": 777269,
	"./RemixIcon/Device/database-2-line.svg": 788246,
	"./RemixIcon/Device/database-fill.svg": 946344,
	"./RemixIcon/Device/database-line.svg": 494295,
	"./RemixIcon/Device/device-fill.svg": 381645,
	"./RemixIcon/Device/device-line.svg": 902248,
	"./RemixIcon/Device/device-recover-fill.svg": 700240,
	"./RemixIcon/Device/device-recover-line.svg": 188572,
	"./RemixIcon/Device/dual-sim-1-fill.svg": 39418,
	"./RemixIcon/Device/dual-sim-1-line.svg": 367597,
	"./RemixIcon/Device/dual-sim-2-fill.svg": 255032,
	"./RemixIcon/Device/dual-sim-2-line.svg": 794591,
	"./RemixIcon/Device/fingerprint-2-fill.svg": 974766,
	"./RemixIcon/Device/fingerprint-2-line.svg": 653084,
	"./RemixIcon/Device/fingerprint-fill.svg": 257629,
	"./RemixIcon/Device/fingerprint-line.svg": 160292,
	"./RemixIcon/Device/gamepad-fill.svg": 570779,
	"./RemixIcon/Device/gamepad-line.svg": 768236,
	"./RemixIcon/Device/gps-fill.svg": 151122,
	"./RemixIcon/Device/gps-line.svg": 225183,
	"./RemixIcon/Device/gradienter-fill.svg": 358799,
	"./RemixIcon/Device/gradienter-line.svg": 397267,
	"./RemixIcon/Device/hard-drive-2-fill.svg": 240043,
	"./RemixIcon/Device/hard-drive-2-line.svg": 937436,
	"./RemixIcon/Device/hard-drive-fill.svg": 804784,
	"./RemixIcon/Device/hard-drive-line.svg": 283717,
	"./RemixIcon/Device/hotspot-fill.svg": 622664,
	"./RemixIcon/Device/hotspot-line.svg": 574250,
	"./RemixIcon/Device/install-fill.svg": 532928,
	"./RemixIcon/Device/install-line.svg": 433192,
	"./RemixIcon/Device/keyboard-box-fill.svg": 993797,
	"./RemixIcon/Device/keyboard-box-line.svg": 778756,
	"./RemixIcon/Device/keyboard-fill.svg": 229633,
	"./RemixIcon/Device/keyboard-line.svg": 99816,
	"./RemixIcon/Device/mac-fill.svg": 61866,
	"./RemixIcon/Device/mac-line.svg": 925034,
	"./RemixIcon/Device/macbook-fill.svg": 751871,
	"./RemixIcon/Device/macbook-line.svg": 468129,
	"./RemixIcon/Device/mouse-fill.svg": 940949,
	"./RemixIcon/Device/mouse-line.svg": 118347,
	"./RemixIcon/Device/phone-fill.svg": 408591,
	"./RemixIcon/Device/phone-find-fill.svg": 527630,
	"./RemixIcon/Device/phone-find-line.svg": 389680,
	"./RemixIcon/Device/phone-line.svg": 5557,
	"./RemixIcon/Device/phone-lock-fill.svg": 769483,
	"./RemixIcon/Device/phone-lock-line.svg": 834206,
	"./RemixIcon/Device/qr-code-fill.svg": 846466,
	"./RemixIcon/Device/qr-code-line.svg": 258409,
	"./RemixIcon/Device/qr-scan-2-fill.svg": 577022,
	"./RemixIcon/Device/qr-scan-2-line.svg": 979580,
	"./RemixIcon/Device/qr-scan-fill.svg": 412557,
	"./RemixIcon/Device/qr-scan-line.svg": 534498,
	"./RemixIcon/Device/radar-fill.svg": 776477,
	"./RemixIcon/Device/radar-line.svg": 694884,
	"./RemixIcon/Device/remote-control-2-fill.svg": 7715,
	"./RemixIcon/Device/remote-control-2-line.svg": 109209,
	"./RemixIcon/Device/remote-control-fill.svg": 925189,
	"./RemixIcon/Device/remote-control-line.svg": 952139,
	"./RemixIcon/Device/restart-fill.svg": 456188,
	"./RemixIcon/Device/restart-line.svg": 798822,
	"./RemixIcon/Device/rotate-lock-fill.svg": 72569,
	"./RemixIcon/Device/rotate-lock-line.svg": 486421,
	"./RemixIcon/Device/router-fill.svg": 284839,
	"./RemixIcon/Device/router-line.svg": 385389,
	"./RemixIcon/Device/rss-fill.svg": 398934,
	"./RemixIcon/Device/rss-line.svg": 321523,
	"./RemixIcon/Device/save-2-fill.svg": 950215,
	"./RemixIcon/Device/save-2-line.svg": 745428,
	"./RemixIcon/Device/save-3-fill.svg": 817089,
	"./RemixIcon/Device/save-3-line.svg": 849100,
	"./RemixIcon/Device/save-fill.svg": 38126,
	"./RemixIcon/Device/save-line.svg": 418605,
	"./RemixIcon/Device/scan-2-fill.svg": 643325,
	"./RemixIcon/Device/scan-2-line.svg": 206006,
	"./RemixIcon/Device/scan-fill.svg": 974758,
	"./RemixIcon/Device/scan-line.svg": 231334,
	"./RemixIcon/Device/sd-card-fill.svg": 660646,
	"./RemixIcon/Device/sd-card-line.svg": 604682,
	"./RemixIcon/Device/sd-card-mini-fill.svg": 46977,
	"./RemixIcon/Device/sd-card-mini-line.svg": 667429,
	"./RemixIcon/Device/sensor-fill.svg": 957460,
	"./RemixIcon/Device/sensor-line.svg": 976198,
	"./RemixIcon/Device/server-fill.svg": 846787,
	"./RemixIcon/Device/server-line.svg": 593311,
	"./RemixIcon/Device/shut-down-fill.svg": 980582,
	"./RemixIcon/Device/shut-down-line.svg": 2163,
	"./RemixIcon/Device/signal-wifi-1-fill.svg": 813852,
	"./RemixIcon/Device/signal-wifi-1-line.svg": 299928,
	"./RemixIcon/Device/signal-wifi-2-fill.svg": 905151,
	"./RemixIcon/Device/signal-wifi-2-line.svg": 524289,
	"./RemixIcon/Device/signal-wifi-3-fill.svg": 503332,
	"./RemixIcon/Device/signal-wifi-3-line.svg": 223989,
	"./RemixIcon/Device/signal-wifi-error-fill.svg": 221919,
	"./RemixIcon/Device/signal-wifi-error-line.svg": 497629,
	"./RemixIcon/Device/signal-wifi-fill.svg": 954828,
	"./RemixIcon/Device/signal-wifi-line.svg": 113528,
	"./RemixIcon/Device/signal-wifi-off-fill.svg": 382592,
	"./RemixIcon/Device/signal-wifi-off-line.svg": 62213,
	"./RemixIcon/Device/sim-card-2-fill.svg": 929402,
	"./RemixIcon/Device/sim-card-2-line.svg": 139431,
	"./RemixIcon/Device/sim-card-fill.svg": 155533,
	"./RemixIcon/Device/sim-card-line.svg": 772233,
	"./RemixIcon/Device/smartphone-fill.svg": 166181,
	"./RemixIcon/Device/smartphone-line.svg": 398721,
	"./RemixIcon/Device/tablet-fill.svg": 658167,
	"./RemixIcon/Device/tablet-line.svg": 128230,
	"./RemixIcon/Device/tv-2-fill.svg": 258634,
	"./RemixIcon/Device/tv-2-line.svg": 755110,
	"./RemixIcon/Device/tv-fill.svg": 849607,
	"./RemixIcon/Device/tv-line.svg": 969083,
	"./RemixIcon/Device/u-disk-fill.svg": 381743,
	"./RemixIcon/Device/u-disk-line.svg": 175161,
	"./RemixIcon/Device/uninstall-fill.svg": 481328,
	"./RemixIcon/Device/uninstall-line.svg": 107875,
	"./RemixIcon/Device/usb-fill.svg": 952802,
	"./RemixIcon/Device/usb-line.svg": 505834,
	"./RemixIcon/Device/wifi-fill.svg": 440575,
	"./RemixIcon/Device/wifi-line.svg": 684959,
	"./RemixIcon/Device/wifi-off-fill.svg": 954792,
	"./RemixIcon/Device/wifi-off-line.svg": 869048,
	"./RemixIcon/Device/wireless-charging-fill.svg": 292899,
	"./RemixIcon/Device/wireless-charging-line.svg": 114026,
	"./RemixIcon/Document/article-fill.svg": 43475,
	"./RemixIcon/Document/article-line.svg": 264013,
	"./RemixIcon/Document/bill-fill.svg": 602365,
	"./RemixIcon/Document/bill-line.svg": 227804,
	"./RemixIcon/Document/book-2-fill.svg": 364604,
	"./RemixIcon/Document/book-2-line.svg": 177240,
	"./RemixIcon/Document/book-3-fill.svg": 158657,
	"./RemixIcon/Document/book-3-line.svg": 569141,
	"./RemixIcon/Document/book-fill.svg": 910836,
	"./RemixIcon/Document/book-line.svg": 535141,
	"./RemixIcon/Document/book-mark-fill.svg": 451828,
	"./RemixIcon/Document/book-mark-line.svg": 799195,
	"./RemixIcon/Document/book-open-fill.svg": 489715,
	"./RemixIcon/Document/book-open-line.svg": 143043,
	"./RemixIcon/Document/book-read-fill.svg": 458794,
	"./RemixIcon/Document/book-read-line.svg": 715543,
	"./RemixIcon/Document/booklet-fill.svg": 71482,
	"./RemixIcon/Document/booklet-line.svg": 85486,
	"./RemixIcon/Document/clipboard-fill.svg": 474368,
	"./RemixIcon/Document/clipboard-line.svg": 909164,
	"./RemixIcon/Document/contacts-book-2-fill.svg": 591092,
	"./RemixIcon/Document/contacts-book-2-line.svg": 410271,
	"./RemixIcon/Document/contacts-book-fill.svg": 598294,
	"./RemixIcon/Document/contacts-book-line.svg": 869502,
	"./RemixIcon/Document/contacts-book-upload-fill.svg": 151276,
	"./RemixIcon/Document/contacts-book-upload-line.svg": 405560,
	"./RemixIcon/Document/draft-fill.svg": 252501,
	"./RemixIcon/Document/draft-line.svg": 227961,
	"./RemixIcon/Document/file-2-fill.svg": 549027,
	"./RemixIcon/Document/file-2-line.svg": 344945,
	"./RemixIcon/Document/file-3-fill.svg": 397197,
	"./RemixIcon/Document/file-3-line.svg": 825099,
	"./RemixIcon/Document/file-4-fill.svg": 137407,
	"./RemixIcon/Document/file-4-line.svg": 202501,
	"./RemixIcon/Document/file-add-fill.svg": 778414,
	"./RemixIcon/Document/file-add-line.svg": 196956,
	"./RemixIcon/Document/file-chart-2-fill.svg": 960538,
	"./RemixIcon/Document/file-chart-2-line.svg": 797597,
	"./RemixIcon/Document/file-chart-fill.svg": 671721,
	"./RemixIcon/Document/file-chart-line.svg": 403429,
	"./RemixIcon/Document/file-cloud-fill.svg": 595901,
	"./RemixIcon/Document/file-cloud-line.svg": 579399,
	"./RemixIcon/Document/file-code-fill.svg": 412360,
	"./RemixIcon/Document/file-code-line.svg": 693474,
	"./RemixIcon/Document/file-copy-2-fill.svg": 248209,
	"./RemixIcon/Document/file-copy-2-line.svg": 8846,
	"./RemixIcon/Document/file-copy-fill.svg": 123746,
	"./RemixIcon/Document/file-copy-line.svg": 988523,
	"./RemixIcon/Document/file-damage-fill.svg": 931958,
	"./RemixIcon/Document/file-damage-line.svg": 66781,
	"./RemixIcon/Document/file-download-fill.svg": 973257,
	"./RemixIcon/Document/file-download-line.svg": 502818,
	"./RemixIcon/Document/file-edit-fill.svg": 487268,
	"./RemixIcon/Document/file-edit-line.svg": 680041,
	"./RemixIcon/Document/file-excel-2-fill.svg": 11783,
	"./RemixIcon/Document/file-excel-2-line.svg": 180680,
	"./RemixIcon/Document/file-excel-fill.svg": 794618,
	"./RemixIcon/Document/file-excel-line.svg": 180569,
	"./RemixIcon/Document/file-fill.svg": 670600,
	"./RemixIcon/Document/file-forbid-fill.svg": 249716,
	"./RemixIcon/Document/file-forbid-line.svg": 736103,
	"./RemixIcon/Document/file-gif-fill.svg": 542986,
	"./RemixIcon/Document/file-gif-line.svg": 42329,
	"./RemixIcon/Document/file-history-fill.svg": 282184,
	"./RemixIcon/Document/file-history-line.svg": 413527,
	"./RemixIcon/Document/file-hwp-fill.svg": 438842,
	"./RemixIcon/Document/file-hwp-line.svg": 497919,
	"./RemixIcon/Document/file-info-fill.svg": 201865,
	"./RemixIcon/Document/file-info-line.svg": 889776,
	"./RemixIcon/Document/file-line.svg": 364581,
	"./RemixIcon/Document/file-list-2-fill.svg": 37358,
	"./RemixIcon/Document/file-list-2-line.svg": 893774,
	"./RemixIcon/Document/file-list-3-fill.svg": 805268,
	"./RemixIcon/Document/file-list-3-line.svg": 306345,
	"./RemixIcon/Document/file-list-fill.svg": 825366,
	"./RemixIcon/Document/file-list-line.svg": 175813,
	"./RemixIcon/Document/file-lock-fill.svg": 196091,
	"./RemixIcon/Document/file-lock-line.svg": 942557,
	"./RemixIcon/Document/file-mark-fill.svg": 984774,
	"./RemixIcon/Document/file-mark-line.svg": 248465,
	"./RemixIcon/Document/file-music-fill.svg": 554975,
	"./RemixIcon/Document/file-music-line.svg": 400069,
	"./RemixIcon/Document/file-paper-2-fill.svg": 357820,
	"./RemixIcon/Document/file-paper-2-line.svg": 625640,
	"./RemixIcon/Document/file-paper-fill.svg": 62525,
	"./RemixIcon/Document/file-paper-line.svg": 340521,
	"./RemixIcon/Document/file-pdf-fill.svg": 424963,
	"./RemixIcon/Document/file-pdf-line.svg": 480978,
	"./RemixIcon/Document/file-ppt-2-fill.svg": 91173,
	"./RemixIcon/Document/file-ppt-2-line.svg": 324879,
	"./RemixIcon/Document/file-ppt-fill.svg": 692803,
	"./RemixIcon/Document/file-ppt-line.svg": 907748,
	"./RemixIcon/Document/file-reduce-fill.svg": 965828,
	"./RemixIcon/Document/file-reduce-line.svg": 182720,
	"./RemixIcon/Document/file-search-fill.svg": 148014,
	"./RemixIcon/Document/file-search-line.svg": 379245,
	"./RemixIcon/Document/file-settings-fill.svg": 384418,
	"./RemixIcon/Document/file-settings-line.svg": 606901,
	"./RemixIcon/Document/file-shield-2-fill.svg": 272103,
	"./RemixIcon/Document/file-shield-2-line.svg": 369064,
	"./RemixIcon/Document/file-shield-fill.svg": 643053,
	"./RemixIcon/Document/file-shield-line.svg": 346702,
	"./RemixIcon/Document/file-shred-fill.svg": 654807,
	"./RemixIcon/Document/file-shred-line.svg": 943475,
	"./RemixIcon/Document/file-text-fill.svg": 169712,
	"./RemixIcon/Document/file-text-line.svg": 490028,
	"./RemixIcon/Document/file-transfer-fill.svg": 18287,
	"./RemixIcon/Document/file-transfer-line.svg": 241506,
	"./RemixIcon/Document/file-unknow-fill.svg": 700104,
	"./RemixIcon/Document/file-unknow-line.svg": 691913,
	"./RemixIcon/Document/file-upload-fill.svg": 919493,
	"./RemixIcon/Document/file-upload-line.svg": 402112,
	"./RemixIcon/Document/file-user-fill.svg": 198711,
	"./RemixIcon/Document/file-user-line.svg": 936581,
	"./RemixIcon/Document/file-warning-fill.svg": 642438,
	"./RemixIcon/Document/file-warning-line.svg": 803198,
	"./RemixIcon/Document/file-word-2-fill.svg": 317223,
	"./RemixIcon/Document/file-word-2-line.svg": 637899,
	"./RemixIcon/Document/file-word-fill.svg": 788098,
	"./RemixIcon/Document/file-word-line.svg": 465553,
	"./RemixIcon/Document/file-zip-fill.svg": 437384,
	"./RemixIcon/Document/file-zip-line.svg": 763393,
	"./RemixIcon/Document/folder-2-fill.svg": 488190,
	"./RemixIcon/Document/folder-2-line.svg": 128273,
	"./RemixIcon/Document/folder-3-fill.svg": 73634,
	"./RemixIcon/Document/folder-3-line.svg": 159230,
	"./RemixIcon/Document/folder-4-fill.svg": 483322,
	"./RemixIcon/Document/folder-4-line.svg": 824952,
	"./RemixIcon/Document/folder-5-fill.svg": 303154,
	"./RemixIcon/Document/folder-5-line.svg": 180240,
	"./RemixIcon/Document/folder-add-fill.svg": 904223,
	"./RemixIcon/Document/folder-add-line.svg": 719672,
	"./RemixIcon/Document/folder-chart-2-fill.svg": 565042,
	"./RemixIcon/Document/folder-chart-2-line.svg": 179483,
	"./RemixIcon/Document/folder-chart-fill.svg": 467262,
	"./RemixIcon/Document/folder-chart-line.svg": 527086,
	"./RemixIcon/Document/folder-download-fill.svg": 730394,
	"./RemixIcon/Document/folder-download-line.svg": 13363,
	"./RemixIcon/Document/folder-fill.svg": 234215,
	"./RemixIcon/Document/folder-forbid-fill.svg": 605106,
	"./RemixIcon/Document/folder-forbid-line.svg": 232610,
	"./RemixIcon/Document/folder-history-fill.svg": 347167,
	"./RemixIcon/Document/folder-history-line.svg": 805541,
	"./RemixIcon/Document/folder-info-fill.svg": 286219,
	"./RemixIcon/Document/folder-info-line.svg": 314148,
	"./RemixIcon/Document/folder-keyhole-fill.svg": 755858,
	"./RemixIcon/Document/folder-keyhole-line.svg": 668860,
	"./RemixIcon/Document/folder-line.svg": 496626,
	"./RemixIcon/Document/folder-lock-fill.svg": 12847,
	"./RemixIcon/Document/folder-lock-line.svg": 339856,
	"./RemixIcon/Document/folder-music-fill.svg": 327287,
	"./RemixIcon/Document/folder-music-line.svg": 351776,
	"./RemixIcon/Document/folder-open-fill.svg": 160520,
	"./RemixIcon/Document/folder-open-line.svg": 77606,
	"./RemixIcon/Document/folder-received-fill.svg": 76373,
	"./RemixIcon/Document/folder-received-line.svg": 225623,
	"./RemixIcon/Document/folder-reduce-fill.svg": 733185,
	"./RemixIcon/Document/folder-reduce-line.svg": 572048,
	"./RemixIcon/Document/folder-settings-fill.svg": 345184,
	"./RemixIcon/Document/folder-settings-line.svg": 953764,
	"./RemixIcon/Document/folder-shared-fill.svg": 878686,
	"./RemixIcon/Document/folder-shared-line.svg": 997617,
	"./RemixIcon/Document/folder-shield-2-fill.svg": 609860,
	"./RemixIcon/Document/folder-shield-2-line.svg": 98471,
	"./RemixIcon/Document/folder-shield-fill.svg": 531918,
	"./RemixIcon/Document/folder-shield-line.svg": 857753,
	"./RemixIcon/Document/folder-transfer-fill.svg": 280438,
	"./RemixIcon/Document/folder-transfer-line.svg": 80166,
	"./RemixIcon/Document/folder-unknow-fill.svg": 605233,
	"./RemixIcon/Document/folder-unknow-line.svg": 343251,
	"./RemixIcon/Document/folder-upload-fill.svg": 26081,
	"./RemixIcon/Document/folder-upload-line.svg": 19735,
	"./RemixIcon/Document/folder-user-fill.svg": 464728,
	"./RemixIcon/Document/folder-user-line.svg": 141788,
	"./RemixIcon/Document/folder-warning-fill.svg": 490108,
	"./RemixIcon/Document/folder-warning-line.svg": 878299,
	"./RemixIcon/Document/folder-zip-fill.svg": 139836,
	"./RemixIcon/Document/folder-zip-line.svg": 926229,
	"./RemixIcon/Document/folders-fill.svg": 833857,
	"./RemixIcon/Document/folders-line.svg": 984056,
	"./RemixIcon/Document/keynote-fill.svg": 706426,
	"./RemixIcon/Document/keynote-line.svg": 752717,
	"./RemixIcon/Document/markdown-fill.svg": 363495,
	"./RemixIcon/Document/markdown-line.svg": 519727,
	"./RemixIcon/Document/newspaper-fill.svg": 523367,
	"./RemixIcon/Document/newspaper-line.svg": 65675,
	"./RemixIcon/Document/numbers-fill.svg": 902684,
	"./RemixIcon/Document/numbers-line.svg": 192092,
	"./RemixIcon/Document/pages-fill.svg": 660458,
	"./RemixIcon/Document/pages-line.svg": 143849,
	"./RemixIcon/Document/sticky-note-2-fill.svg": 476795,
	"./RemixIcon/Document/sticky-note-2-line.svg": 613181,
	"./RemixIcon/Document/sticky-note-fill.svg": 190715,
	"./RemixIcon/Document/sticky-note-line.svg": 592181,
	"./RemixIcon/Document/survey-fill.svg": 32054,
	"./RemixIcon/Document/survey-line.svg": 33661,
	"./RemixIcon/Document/task-fill.svg": 183003,
	"./RemixIcon/Document/task-line.svg": 471301,
	"./RemixIcon/Document/todo-fill.svg": 934996,
	"./RemixIcon/Document/todo-line.svg": 510720,
	"./RemixIcon/Editor/a-b.svg": 854173,
	"./RemixIcon/Editor/align-bottom.svg": 548974,
	"./RemixIcon/Editor/align-center.svg": 440181,
	"./RemixIcon/Editor/align-justify.svg": 37666,
	"./RemixIcon/Editor/align-left.svg": 673990,
	"./RemixIcon/Editor/align-right.svg": 132105,
	"./RemixIcon/Editor/align-top.svg": 535617,
	"./RemixIcon/Editor/align-vertically.svg": 847560,
	"./RemixIcon/Editor/asterisk.svg": 269011,
	"./RemixIcon/Editor/attachment-2.svg": 487939,
	"./RemixIcon/Editor/bold.svg": 23924,
	"./RemixIcon/Editor/bring-forward.svg": 841304,
	"./RemixIcon/Editor/bring-to-front.svg": 443091,
	"./RemixIcon/Editor/code-view.svg": 725307,
	"./RemixIcon/Editor/delete-column.svg": 993806,
	"./RemixIcon/Editor/delete-row.svg": 285596,
	"./RemixIcon/Editor/double-quotes-l.svg": 45138,
	"./RemixIcon/Editor/double-quotes-r.svg": 156287,
	"./RemixIcon/Editor/emphasis-cn.svg": 556304,
	"./RemixIcon/Editor/emphasis.svg": 509742,
	"./RemixIcon/Editor/english-input.svg": 895069,
	"./RemixIcon/Editor/flow-chart.svg": 415915,
	"./RemixIcon/Editor/font-color.svg": 982693,
	"./RemixIcon/Editor/font-size-2.svg": 148195,
	"./RemixIcon/Editor/font-size.svg": 999694,
	"./RemixIcon/Editor/format-clear.svg": 165280,
	"./RemixIcon/Editor/functions.svg": 824765,
	"./RemixIcon/Editor/h-1.svg": 911687,
	"./RemixIcon/Editor/h-2.svg": 901040,
	"./RemixIcon/Editor/h-3.svg": 623363,
	"./RemixIcon/Editor/h-4.svg": 849018,
	"./RemixIcon/Editor/h-5.svg": 189423,
	"./RemixIcon/Editor/h-6.svg": 53651,
	"./RemixIcon/Editor/hashtag.svg": 571899,
	"./RemixIcon/Editor/heading.svg": 247217,
	"./RemixIcon/Editor/indent-decrease.svg": 143887,
	"./RemixIcon/Editor/indent-increase.svg": 658862,
	"./RemixIcon/Editor/input-cursor-move.svg": 742856,
	"./RemixIcon/Editor/insert-column-left.svg": 886268,
	"./RemixIcon/Editor/insert-column-right.svg": 20872,
	"./RemixIcon/Editor/insert-row-bottom.svg": 39040,
	"./RemixIcon/Editor/insert-row-top.svg": 938021,
	"./RemixIcon/Editor/italic.svg": 63778,
	"./RemixIcon/Editor/line-height.svg": 124177,
	"./RemixIcon/Editor/link-m.svg": 805372,
	"./RemixIcon/Editor/link-unlink-m.svg": 858530,
	"./RemixIcon/Editor/link-unlink.svg": 518744,
	"./RemixIcon/Editor/link.svg": 502520,
	"./RemixIcon/Editor/list-check-2.svg": 970226,
	"./RemixIcon/Editor/list-check.svg": 507796,
	"./RemixIcon/Editor/list-ordered.svg": 610978,
	"./RemixIcon/Editor/list-unordered.svg": 309756,
	"./RemixIcon/Editor/merge-cells-horizontal.svg": 522854,
	"./RemixIcon/Editor/merge-cells-vertical.svg": 878629,
	"./RemixIcon/Editor/mind-map.svg": 670089,
	"./RemixIcon/Editor/node-tree.svg": 829032,
	"./RemixIcon/Editor/number-0.svg": 8467,
	"./RemixIcon/Editor/number-1.svg": 42672,
	"./RemixIcon/Editor/number-2.svg": 693140,
	"./RemixIcon/Editor/number-3.svg": 287355,
	"./RemixIcon/Editor/number-4.svg": 812168,
	"./RemixIcon/Editor/number-5.svg": 828059,
	"./RemixIcon/Editor/number-6.svg": 474869,
	"./RemixIcon/Editor/number-7.svg": 303407,
	"./RemixIcon/Editor/number-8.svg": 229682,
	"./RemixIcon/Editor/number-9.svg": 594560,
	"./RemixIcon/Editor/omega.svg": 247877,
	"./RemixIcon/Editor/organization-chart.svg": 932694,
	"./RemixIcon/Editor/page-separator.svg": 982632,
	"./RemixIcon/Editor/paragraph.svg": 744470,
	"./RemixIcon/Editor/pinyin-input.svg": 735795,
	"./RemixIcon/Editor/question-mark.svg": 491380,
	"./RemixIcon/Editor/rounded-corner.svg": 51094,
	"./RemixIcon/Editor/send-backward.svg": 876233,
	"./RemixIcon/Editor/send-to-back.svg": 438071,
	"./RemixIcon/Editor/separator.svg": 319415,
	"./RemixIcon/Editor/single-quotes-l.svg": 453368,
	"./RemixIcon/Editor/single-quotes-r.svg": 132563,
	"./RemixIcon/Editor/sort-asc.svg": 726413,
	"./RemixIcon/Editor/sort-desc.svg": 295734,
	"./RemixIcon/Editor/space.svg": 366326,
	"./RemixIcon/Editor/split-cells-horizontal.svg": 942409,
	"./RemixIcon/Editor/split-cells-vertical.svg": 584916,
	"./RemixIcon/Editor/strikethrough-2.svg": 804979,
	"./RemixIcon/Editor/strikethrough.svg": 875491,
	"./RemixIcon/Editor/subscript-2.svg": 99076,
	"./RemixIcon/Editor/subscript.svg": 729555,
	"./RemixIcon/Editor/superscript-2.svg": 210706,
	"./RemixIcon/Editor/superscript.svg": 348014,
	"./RemixIcon/Editor/table-2.svg": 508659,
	"./RemixIcon/Editor/text-direction-l.svg": 900227,
	"./RemixIcon/Editor/text-direction-r.svg": 788767,
	"./RemixIcon/Editor/text-spacing.svg": 635469,
	"./RemixIcon/Editor/text-wrap.svg": 249437,
	"./RemixIcon/Editor/text.svg": 630336,
	"./RemixIcon/Editor/translate-2.svg": 775334,
	"./RemixIcon/Editor/translate.svg": 15266,
	"./RemixIcon/Editor/underline.svg": 679410,
	"./RemixIcon/Editor/wubi-input.svg": 843514,
	"./RemixIcon/Finance/24-hours-fill.svg": 677842,
	"./RemixIcon/Finance/24-hours-line.svg": 336516,
	"./RemixIcon/Finance/auction-fill.svg": 870160,
	"./RemixIcon/Finance/auction-line.svg": 181733,
	"./RemixIcon/Finance/bank-card-2-fill.svg": 308236,
	"./RemixIcon/Finance/bank-card-2-line.svg": 326899,
	"./RemixIcon/Finance/bank-card-fill.svg": 95220,
	"./RemixIcon/Finance/bank-card-line.svg": 325412,
	"./RemixIcon/Finance/bit-coin-fill.svg": 253760,
	"./RemixIcon/Finance/bit-coin-line.svg": 52960,
	"./RemixIcon/Finance/coin-fill.svg": 206630,
	"./RemixIcon/Finance/coin-line.svg": 682513,
	"./RemixIcon/Finance/coins-fill.svg": 412603,
	"./RemixIcon/Finance/coins-line.svg": 658021,
	"./RemixIcon/Finance/copper-coin-fill.svg": 755081,
	"./RemixIcon/Finance/copper-coin-line.svg": 478397,
	"./RemixIcon/Finance/copper-diamond-fill.svg": 93293,
	"./RemixIcon/Finance/copper-diamond-line.svg": 173235,
	"./RemixIcon/Finance/coupon-2-fill.svg": 435105,
	"./RemixIcon/Finance/coupon-2-line.svg": 247273,
	"./RemixIcon/Finance/coupon-3-fill.svg": 826445,
	"./RemixIcon/Finance/coupon-3-line.svg": 661479,
	"./RemixIcon/Finance/coupon-4-fill.svg": 24187,
	"./RemixIcon/Finance/coupon-4-line.svg": 736133,
	"./RemixIcon/Finance/coupon-5-fill.svg": 366287,
	"./RemixIcon/Finance/coupon-5-line.svg": 622029,
	"./RemixIcon/Finance/coupon-fill.svg": 941622,
	"./RemixIcon/Finance/coupon-line.svg": 920127,
	"./RemixIcon/Finance/currency-fill.svg": 908368,
	"./RemixIcon/Finance/currency-line.svg": 33562,
	"./RemixIcon/Finance/exchange-box-fill.svg": 171726,
	"./RemixIcon/Finance/exchange-box-line.svg": 526138,
	"./RemixIcon/Finance/exchange-cny-fill.svg": 286786,
	"./RemixIcon/Finance/exchange-cny-line.svg": 119470,
	"./RemixIcon/Finance/exchange-dollar-fill.svg": 664950,
	"./RemixIcon/Finance/exchange-dollar-line.svg": 639721,
	"./RemixIcon/Finance/exchange-fill.svg": 792146,
	"./RemixIcon/Finance/exchange-funds-fill.svg": 233309,
	"./RemixIcon/Finance/exchange-funds-line.svg": 651709,
	"./RemixIcon/Finance/exchange-line.svg": 361552,
	"./RemixIcon/Finance/funds-box-fill.svg": 280190,
	"./RemixIcon/Finance/funds-box-line.svg": 345805,
	"./RemixIcon/Finance/funds-fill.svg": 177196,
	"./RemixIcon/Finance/funds-line.svg": 840057,
	"./RemixIcon/Finance/gift-2-fill.svg": 263610,
	"./RemixIcon/Finance/gift-2-line.svg": 425494,
	"./RemixIcon/Finance/gift-fill.svg": 85495,
	"./RemixIcon/Finance/gift-line.svg": 511147,
	"./RemixIcon/Finance/hand-coin-fill.svg": 647064,
	"./RemixIcon/Finance/hand-coin-line.svg": 184867,
	"./RemixIcon/Finance/hand-heart-fill.svg": 623162,
	"./RemixIcon/Finance/hand-heart-line.svg": 975597,
	"./RemixIcon/Finance/increase-decrease-fill.svg": 52629,
	"./RemixIcon/Finance/increase-decrease-line.svg": 787417,
	"./RemixIcon/Finance/money-cny-box-fill.svg": 484872,
	"./RemixIcon/Finance/money-cny-box-line.svg": 999244,
	"./RemixIcon/Finance/money-cny-circle-fill.svg": 658538,
	"./RemixIcon/Finance/money-cny-circle-line.svg": 424456,
	"./RemixIcon/Finance/money-dollar-box-fill.svg": 763717,
	"./RemixIcon/Finance/money-dollar-box-line.svg": 618646,
	"./RemixIcon/Finance/money-dollar-circle-fill.svg": 849564,
	"./RemixIcon/Finance/money-dollar-circle-line.svg": 624817,
	"./RemixIcon/Finance/money-euro-box-fill.svg": 620370,
	"./RemixIcon/Finance/money-euro-box-line.svg": 301707,
	"./RemixIcon/Finance/money-euro-circle-fill.svg": 369024,
	"./RemixIcon/Finance/money-euro-circle-line.svg": 11408,
	"./RemixIcon/Finance/money-pound-box-fill.svg": 494082,
	"./RemixIcon/Finance/money-pound-box-line.svg": 785157,
	"./RemixIcon/Finance/money-pound-circle-fill.svg": 549958,
	"./RemixIcon/Finance/money-pound-circle-line.svg": 369863,
	"./RemixIcon/Finance/percent-fill.svg": 483189,
	"./RemixIcon/Finance/percent-line.svg": 898903,
	"./RemixIcon/Finance/price-tag-2-fill.svg": 242902,
	"./RemixIcon/Finance/price-tag-2-line.svg": 223741,
	"./RemixIcon/Finance/price-tag-3-fill.svg": 897522,
	"./RemixIcon/Finance/price-tag-3-line.svg": 688816,
	"./RemixIcon/Finance/price-tag-fill.svg": 622583,
	"./RemixIcon/Finance/price-tag-line.svg": 609704,
	"./RemixIcon/Finance/red-packet-fill.svg": 862104,
	"./RemixIcon/Finance/red-packet-line.svg": 857461,
	"./RemixIcon/Finance/refund-2-fill.svg": 895028,
	"./RemixIcon/Finance/refund-2-line.svg": 250902,
	"./RemixIcon/Finance/refund-fill.svg": 844440,
	"./RemixIcon/Finance/refund-line.svg": 800594,
	"./RemixIcon/Finance/safe-2-fill.svg": 123755,
	"./RemixIcon/Finance/safe-2-line.svg": 918050,
	"./RemixIcon/Finance/safe-fill.svg": 517724,
	"./RemixIcon/Finance/safe-line.svg": 126821,
	"./RemixIcon/Finance/secure-payment-fill.svg": 113275,
	"./RemixIcon/Finance/secure-payment-line.svg": 171630,
	"./RemixIcon/Finance/shopping-bag-2-fill.svg": 600129,
	"./RemixIcon/Finance/shopping-bag-2-line.svg": 441877,
	"./RemixIcon/Finance/shopping-bag-3-fill.svg": 525220,
	"./RemixIcon/Finance/shopping-bag-3-line.svg": 789634,
	"./RemixIcon/Finance/shopping-bag-fill.svg": 600037,
	"./RemixIcon/Finance/shopping-bag-line.svg": 124420,
	"./RemixIcon/Finance/shopping-basket-2-fill.svg": 118037,
	"./RemixIcon/Finance/shopping-basket-2-line.svg": 862088,
	"./RemixIcon/Finance/shopping-basket-fill.svg": 933649,
	"./RemixIcon/Finance/shopping-basket-line.svg": 556697,
	"./RemixIcon/Finance/shopping-cart-2-fill.svg": 536485,
	"./RemixIcon/Finance/shopping-cart-2-line.svg": 214118,
	"./RemixIcon/Finance/shopping-cart-fill.svg": 315484,
	"./RemixIcon/Finance/shopping-cart-line.svg": 813707,
	"./RemixIcon/Finance/stock-fill.svg": 287489,
	"./RemixIcon/Finance/stock-line.svg": 103337,
	"./RemixIcon/Finance/swap-box-fill.svg": 282827,
	"./RemixIcon/Finance/swap-box-line.svg": 66614,
	"./RemixIcon/Finance/swap-fill.svg": 111711,
	"./RemixIcon/Finance/swap-line.svg": 979757,
	"./RemixIcon/Finance/ticket-2-fill.svg": 979281,
	"./RemixIcon/Finance/ticket-2-line.svg": 189245,
	"./RemixIcon/Finance/ticket-fill.svg": 151432,
	"./RemixIcon/Finance/ticket-line.svg": 236793,
	"./RemixIcon/Finance/trophy-fill.svg": 32101,
	"./RemixIcon/Finance/trophy-line.svg": 91388,
	"./RemixIcon/Finance/vip-crown-2-fill.svg": 84025,
	"./RemixIcon/Finance/vip-crown-2-line.svg": 436154,
	"./RemixIcon/Finance/vip-crown-fill.svg": 932471,
	"./RemixIcon/Finance/vip-crown-line.svg": 692322,
	"./RemixIcon/Finance/vip-diamond-fill.svg": 278999,
	"./RemixIcon/Finance/vip-diamond-line.svg": 729382,
	"./RemixIcon/Finance/vip-fill.svg": 639471,
	"./RemixIcon/Finance/vip-line.svg": 486768,
	"./RemixIcon/Finance/wallet-2-fill.svg": 50485,
	"./RemixIcon/Finance/wallet-2-line.svg": 906482,
	"./RemixIcon/Finance/wallet-3-fill.svg": 219009,
	"./RemixIcon/Finance/wallet-3-line.svg": 150193,
	"./RemixIcon/Finance/wallet-fill.svg": 183451,
	"./RemixIcon/Finance/wallet-line.svg": 559393,
	"./RemixIcon/Finance/water-flash-fill.svg": 106228,
	"./RemixIcon/Finance/water-flash-line.svg": 550642,
	"./RemixIcon/Health/capsule-fill.svg": 600218,
	"./RemixIcon/Health/capsule-line.svg": 246871,
	"./RemixIcon/Health/dislike-fill.svg": 157334,
	"./RemixIcon/Health/dislike-line.svg": 909021,
	"./RemixIcon/Health/dossier-fill.svg": 410287,
	"./RemixIcon/Health/dossier-line.svg": 639092,
	"./RemixIcon/Health/empathize-fill.svg": 28475,
	"./RemixIcon/Health/empathize-line.svg": 29344,
	"./RemixIcon/Health/first-aid-kit-fill.svg": 215549,
	"./RemixIcon/Health/first-aid-kit-line.svg": 527681,
	"./RemixIcon/Health/flask-fill.svg": 11573,
	"./RemixIcon/Health/flask-line.svg": 534248,
	"./RemixIcon/Health/hand-sanitizer-fill.svg": 382876,
	"./RemixIcon/Health/hand-sanitizer-line.svg": 919116,
	"./RemixIcon/Health/health-book-fill.svg": 152986,
	"./RemixIcon/Health/health-book-line.svg": 97429,
	"./RemixIcon/Health/heart-2-fill.svg": 730287,
	"./RemixIcon/Health/heart-2-line.svg": 153977,
	"./RemixIcon/Health/heart-3-fill.svg": 851431,
	"./RemixIcon/Health/heart-3-line.svg": 271984,
	"./RemixIcon/Health/heart-add-fill.svg": 678598,
	"./RemixIcon/Health/heart-add-line.svg": 771888,
	"./RemixIcon/Health/heart-fill.svg": 539217,
	"./RemixIcon/Health/heart-line.svg": 87575,
	"./RemixIcon/Health/heart-pulse-fill.svg": 494753,
	"./RemixIcon/Health/heart-pulse-line.svg": 454325,
	"./RemixIcon/Health/hearts-fill.svg": 570344,
	"./RemixIcon/Health/hearts-line.svg": 158555,
	"./RemixIcon/Health/infrared-thermometer-fill.svg": 387141,
	"./RemixIcon/Health/infrared-thermometer-line.svg": 735577,
	"./RemixIcon/Health/lungs-fill.svg": 203308,
	"./RemixIcon/Health/lungs-line.svg": 195585,
	"./RemixIcon/Health/medicine-bottle-fill.svg": 741197,
	"./RemixIcon/Health/medicine-bottle-line.svg": 640815,
	"./RemixIcon/Health/mental-health-fill.svg": 612350,
	"./RemixIcon/Health/mental-health-line.svg": 245985,
	"./RemixIcon/Health/microscope-fill.svg": 423153,
	"./RemixIcon/Health/microscope-line.svg": 606422,
	"./RemixIcon/Health/nurse-fill.svg": 122838,
	"./RemixIcon/Health/nurse-line.svg": 797754,
	"./RemixIcon/Health/psychotherapy-fill.svg": 333498,
	"./RemixIcon/Health/psychotherapy-line.svg": 4017,
	"./RemixIcon/Health/pulse-fill.svg": 849801,
	"./RemixIcon/Health/pulse-line.svg": 571900,
	"./RemixIcon/Health/rest-time-fill.svg": 647032,
	"./RemixIcon/Health/rest-time-line.svg": 158245,
	"./RemixIcon/Health/stethoscope-fill.svg": 424420,
	"./RemixIcon/Health/stethoscope-line.svg": 17683,
	"./RemixIcon/Health/surgical-mask-fill.svg": 772041,
	"./RemixIcon/Health/surgical-mask-line.svg": 49359,
	"./RemixIcon/Health/syringe-fill.svg": 66666,
	"./RemixIcon/Health/syringe-line.svg": 631071,
	"./RemixIcon/Health/test-tube-fill.svg": 610869,
	"./RemixIcon/Health/test-tube-line.svg": 569040,
	"./RemixIcon/Health/thermometer-fill.svg": 681751,
	"./RemixIcon/Health/thermometer-line.svg": 14184,
	"./RemixIcon/Health/virus-fill.svg": 473524,
	"./RemixIcon/Health/virus-line.svg": 102938,
	"./RemixIcon/Health/zzz-fill.svg": 365369,
	"./RemixIcon/Health/zzz-line.svg": 889632,
	"./RemixIcon/Logos/alipay-fill.svg": 291896,
	"./RemixIcon/Logos/alipay-line.svg": 254814,
	"./RemixIcon/Logos/amazon-fill.svg": 451508,
	"./RemixIcon/Logos/amazon-line.svg": 881585,
	"./RemixIcon/Logos/android-fill.svg": 551059,
	"./RemixIcon/Logos/android-line.svg": 358450,
	"./RemixIcon/Logos/angularjs-fill.svg": 521174,
	"./RemixIcon/Logos/angularjs-line.svg": 447503,
	"./RemixIcon/Logos/app-store-fill.svg": 583007,
	"./RemixIcon/Logos/app-store-line.svg": 695111,
	"./RemixIcon/Logos/apple-fill.svg": 191616,
	"./RemixIcon/Logos/apple-line.svg": 768782,
	"./RemixIcon/Logos/baidu-fill.svg": 625986,
	"./RemixIcon/Logos/baidu-line.svg": 691835,
	"./RemixIcon/Logos/behance-fill.svg": 223258,
	"./RemixIcon/Logos/behance-line.svg": 866782,
	"./RemixIcon/Logos/bilibili-fill.svg": 873529,
	"./RemixIcon/Logos/bilibili-line.svg": 730736,
	"./RemixIcon/Logos/centos-fill.svg": 842436,
	"./RemixIcon/Logos/centos-line.svg": 451439,
	"./RemixIcon/Logos/chrome-fill.svg": 684966,
	"./RemixIcon/Logos/chrome-line.svg": 820317,
	"./RemixIcon/Logos/codepen-fill.svg": 328736,
	"./RemixIcon/Logos/codepen-line.svg": 310366,
	"./RemixIcon/Logos/coreos-fill.svg": 114865,
	"./RemixIcon/Logos/coreos-line.svg": 928921,
	"./RemixIcon/Logos/dingding-fill.svg": 673130,
	"./RemixIcon/Logos/dingding-line.svg": 338586,
	"./RemixIcon/Logos/discord-fill.svg": 512891,
	"./RemixIcon/Logos/discord-line.svg": 888505,
	"./RemixIcon/Logos/disqus-fill.svg": 327253,
	"./RemixIcon/Logos/disqus-line.svg": 153535,
	"./RemixIcon/Logos/douban-fill.svg": 586313,
	"./RemixIcon/Logos/douban-line.svg": 708797,
	"./RemixIcon/Logos/dribbble-fill.svg": 356211,
	"./RemixIcon/Logos/dribbble-line.svg": 657422,
	"./RemixIcon/Logos/drive-fill.svg": 416921,
	"./RemixIcon/Logos/drive-line.svg": 316647,
	"./RemixIcon/Logos/dropbox-fill.svg": 92472,
	"./RemixIcon/Logos/dropbox-line.svg": 272636,
	"./RemixIcon/Logos/edge-fill.svg": 849920,
	"./RemixIcon/Logos/edge-line.svg": 334613,
	"./RemixIcon/Logos/evernote-fill.svg": 506870,
	"./RemixIcon/Logos/evernote-line.svg": 528506,
	"./RemixIcon/Logos/facebook-box-fill.svg": 115660,
	"./RemixIcon/Logos/facebook-box-line.svg": 735507,
	"./RemixIcon/Logos/facebook-circle-fill.svg": 909986,
	"./RemixIcon/Logos/facebook-circle-line.svg": 786968,
	"./RemixIcon/Logos/facebook-fill.svg": 152333,
	"./RemixIcon/Logos/facebook-line.svg": 237386,
	"./RemixIcon/Logos/finder-fill.svg": 876781,
	"./RemixIcon/Logos/finder-line.svg": 68599,
	"./RemixIcon/Logos/firefox-fill.svg": 419410,
	"./RemixIcon/Logos/firefox-line.svg": 375532,
	"./RemixIcon/Logos/flutter-fill.svg": 78685,
	"./RemixIcon/Logos/flutter-line.svg": 872456,
	"./RemixIcon/Logos/gatsby-fill.svg": 41560,
	"./RemixIcon/Logos/gatsby-line.svg": 769299,
	"./RemixIcon/Logos/github-fill.svg": 538927,
	"./RemixIcon/Logos/github-line.svg": 919617,
	"./RemixIcon/Logos/gitlab-fill.svg": 944513,
	"./RemixIcon/Logos/gitlab-line.svg": 830223,
	"./RemixIcon/Logos/google-fill.svg": 67036,
	"./RemixIcon/Logos/google-line.svg": 293463,
	"./RemixIcon/Logos/google-play-fill.svg": 517429,
	"./RemixIcon/Logos/google-play-line.svg": 296515,
	"./RemixIcon/Logos/honor-of-kings-fill.svg": 466951,
	"./RemixIcon/Logos/honor-of-kings-line.svg": 895699,
	"./RemixIcon/Logos/ie-fill.svg": 302119,
	"./RemixIcon/Logos/ie-line.svg": 334834,
	"./RemixIcon/Logos/instagram-fill.svg": 769715,
	"./RemixIcon/Logos/instagram-line.svg": 719236,
	"./RemixIcon/Logos/invision-fill.svg": 285051,
	"./RemixIcon/Logos/invision-line.svg": 560066,
	"./RemixIcon/Logos/kakao-talk-fill.svg": 973392,
	"./RemixIcon/Logos/kakao-talk-line.svg": 635400,
	"./RemixIcon/Logos/line-fill.svg": 688488,
	"./RemixIcon/Logos/line-line.svg": 423473,
	"./RemixIcon/Logos/linkedin-box-fill.svg": 723737,
	"./RemixIcon/Logos/linkedin-box-line.svg": 495525,
	"./RemixIcon/Logos/linkedin-fill.svg": 223778,
	"./RemixIcon/Logos/linkedin-line.svg": 877742,
	"./RemixIcon/Logos/mastercard-fill.svg": 134561,
	"./RemixIcon/Logos/mastercard-line.svg": 218299,
	"./RemixIcon/Logos/mastodon-fill.svg": 671680,
	"./RemixIcon/Logos/mastodon-line.svg": 132605,
	"./RemixIcon/Logos/medium-fill.svg": 618072,
	"./RemixIcon/Logos/medium-line.svg": 107820,
	"./RemixIcon/Logos/messenger-fill.svg": 291700,
	"./RemixIcon/Logos/messenger-line.svg": 524384,
	"./RemixIcon/Logos/microsoft-fill.svg": 903251,
	"./RemixIcon/Logos/microsoft-line.svg": 119293,
	"./RemixIcon/Logos/mini-program-fill.svg": 733552,
	"./RemixIcon/Logos/mini-program-line.svg": 661457,
	"./RemixIcon/Logos/netease-cloud-music-fill.svg": 671215,
	"./RemixIcon/Logos/netease-cloud-music-line.svg": 465094,
	"./RemixIcon/Logos/netflix-fill.svg": 384719,
	"./RemixIcon/Logos/netflix-line.svg": 61834,
	"./RemixIcon/Logos/npmjs-fill.svg": 679941,
	"./RemixIcon/Logos/npmjs-line.svg": 832053,
	"./RemixIcon/Logos/open-source-fill.svg": 230973,
	"./RemixIcon/Logos/open-source-line.svg": 449027,
	"./RemixIcon/Logos/opera-fill.svg": 377129,
	"./RemixIcon/Logos/opera-line.svg": 220129,
	"./RemixIcon/Logos/patreon-fill.svg": 225622,
	"./RemixIcon/Logos/patreon-line.svg": 112285,
	"./RemixIcon/Logos/paypal-fill.svg": 665896,
	"./RemixIcon/Logos/paypal-line.svg": 458082,
	"./RemixIcon/Logos/pinterest-fill.svg": 337291,
	"./RemixIcon/Logos/pinterest-line.svg": 80592,
	"./RemixIcon/Logos/pixelfed-fill.svg": 330176,
	"./RemixIcon/Logos/pixelfed-line.svg": 329102,
	"./RemixIcon/Logos/playstation-fill.svg": 335759,
	"./RemixIcon/Logos/playstation-line.svg": 791660,
	"./RemixIcon/Logos/product-hunt-fill.svg": 408253,
	"./RemixIcon/Logos/product-hunt-line.svg": 912597,
	"./RemixIcon/Logos/qq-fill.svg": 232666,
	"./RemixIcon/Logos/qq-line.svg": 792641,
	"./RemixIcon/Logos/reactjs-fill.svg": 688087,
	"./RemixIcon/Logos/reactjs-line.svg": 154256,
	"./RemixIcon/Logos/reddit-fill.svg": 772230,
	"./RemixIcon/Logos/reddit-line.svg": 489370,
	"./RemixIcon/Logos/remixicon-fill.svg": 428974,
	"./RemixIcon/Logos/remixicon-line.svg": 131298,
	"./RemixIcon/Logos/safari-fill.svg": 959020,
	"./RemixIcon/Logos/safari-line.svg": 337822,
	"./RemixIcon/Logos/skype-fill.svg": 919885,
	"./RemixIcon/Logos/skype-line.svg": 108747,
	"./RemixIcon/Logos/slack-fill.svg": 481635,
	"./RemixIcon/Logos/slack-line.svg": 386740,
	"./RemixIcon/Logos/snapchat-fill.svg": 256370,
	"./RemixIcon/Logos/snapchat-line.svg": 171770,
	"./RemixIcon/Logos/soundcloud-fill.svg": 665187,
	"./RemixIcon/Logos/soundcloud-line.svg": 936198,
	"./RemixIcon/Logos/spectrum-fill.svg": 777753,
	"./RemixIcon/Logos/spectrum-line.svg": 863616,
	"./RemixIcon/Logos/spotify-fill.svg": 163591,
	"./RemixIcon/Logos/spotify-line.svg": 64843,
	"./RemixIcon/Logos/stack-overflow-fill.svg": 855106,
	"./RemixIcon/Logos/stack-overflow-line.svg": 106791,
	"./RemixIcon/Logos/stackshare-fill.svg": 987129,
	"./RemixIcon/Logos/stackshare-line.svg": 705384,
	"./RemixIcon/Logos/steam-fill.svg": 594145,
	"./RemixIcon/Logos/steam-line.svg": 80785,
	"./RemixIcon/Logos/switch-fill.svg": 901779,
	"./RemixIcon/Logos/switch-line.svg": 510143,
	"./RemixIcon/Logos/taobao-fill.svg": 861271,
	"./RemixIcon/Logos/taobao-line.svg": 50659,
	"./RemixIcon/Logos/telegram-fill.svg": 788677,
	"./RemixIcon/Logos/telegram-line.svg": 282780,
	"./RemixIcon/Logos/trello-fill.svg": 817772,
	"./RemixIcon/Logos/trello-line.svg": 470218,
	"./RemixIcon/Logos/tumblr-fill.svg": 487961,
	"./RemixIcon/Logos/tumblr-line.svg": 328404,
	"./RemixIcon/Logos/twitch-fill.svg": 667891,
	"./RemixIcon/Logos/twitch-line.svg": 282593,
	"./RemixIcon/Logos/twitter-fill.svg": 501920,
	"./RemixIcon/Logos/twitter-line.svg": 921950,
	"./RemixIcon/Logos/ubuntu-fill.svg": 508110,
	"./RemixIcon/Logos/ubuntu-line.svg": 265379,
	"./RemixIcon/Logos/unsplash-fill.svg": 928302,
	"./RemixIcon/Logos/unsplash-line.svg": 333255,
	"./RemixIcon/Logos/vimeo-fill.svg": 757700,
	"./RemixIcon/Logos/vimeo-line.svg": 90850,
	"./RemixIcon/Logos/visa-fill.svg": 408993,
	"./RemixIcon/Logos/visa-line.svg": 567343,
	"./RemixIcon/Logos/vuejs-fill.svg": 491547,
	"./RemixIcon/Logos/vuejs-line.svg": 864678,
	"./RemixIcon/Logos/wechat-2-fill.svg": 296268,
	"./RemixIcon/Logos/wechat-2-line.svg": 15009,
	"./RemixIcon/Logos/wechat-fill.svg": 849069,
	"./RemixIcon/Logos/wechat-line.svg": 744976,
	"./RemixIcon/Logos/wechat-pay-fill.svg": 836434,
	"./RemixIcon/Logos/wechat-pay-line.svg": 150871,
	"./RemixIcon/Logos/weibo-fill.svg": 85954,
	"./RemixIcon/Logos/weibo-line.svg": 546290,
	"./RemixIcon/Logos/whatsapp-fill.svg": 820844,
	"./RemixIcon/Logos/whatsapp-line.svg": 789827,
	"./RemixIcon/Logos/windows-fill.svg": 160389,
	"./RemixIcon/Logos/windows-line.svg": 588486,
	"./RemixIcon/Logos/xbox-fill.svg": 692915,
	"./RemixIcon/Logos/xbox-line.svg": 326886,
	"./RemixIcon/Logos/xing-fill.svg": 639666,
	"./RemixIcon/Logos/xing-line.svg": 702472,
	"./RemixIcon/Logos/youtube-fill.svg": 371272,
	"./RemixIcon/Logos/youtube-line.svg": 812817,
	"./RemixIcon/Logos/zcool-fill.svg": 841404,
	"./RemixIcon/Logos/zcool-line.svg": 324498,
	"./RemixIcon/Logos/zhihu-fill.svg": 26053,
	"./RemixIcon/Logos/zhihu-line.svg": 74170,
	"./RemixIcon/Map/anchor-fill.svg": 89133,
	"./RemixIcon/Map/anchor-line.svg": 778850,
	"./RemixIcon/Map/barricade-fill.svg": 482133,
	"./RemixIcon/Map/barricade-line.svg": 97174,
	"./RemixIcon/Map/bike-fill.svg": 831533,
	"./RemixIcon/Map/bike-line.svg": 602416,
	"./RemixIcon/Map/bus-2-fill.svg": 620273,
	"./RemixIcon/Map/bus-2-line.svg": 962275,
	"./RemixIcon/Map/bus-fill.svg": 961822,
	"./RemixIcon/Map/bus-line.svg": 861934,
	"./RemixIcon/Map/bus-wifi-fill.svg": 176233,
	"./RemixIcon/Map/bus-wifi-line.svg": 668669,
	"./RemixIcon/Map/car-fill.svg": 485937,
	"./RemixIcon/Map/car-line.svg": 967233,
	"./RemixIcon/Map/car-washing-fill.svg": 194907,
	"./RemixIcon/Map/car-washing-line.svg": 197055,
	"./RemixIcon/Map/caravan-fill.svg": 392705,
	"./RemixIcon/Map/caravan-line.svg": 607817,
	"./RemixIcon/Map/charging-pile-2-fill.svg": 261556,
	"./RemixIcon/Map/charging-pile-2-line.svg": 471796,
	"./RemixIcon/Map/charging-pile-fill.svg": 564124,
	"./RemixIcon/Map/charging-pile-line.svg": 267461,
	"./RemixIcon/Map/china-railway-fill.svg": 593964,
	"./RemixIcon/Map/china-railway-line.svg": 611128,
	"./RemixIcon/Map/compass-2-fill.svg": 825635,
	"./RemixIcon/Map/compass-2-line.svg": 290952,
	"./RemixIcon/Map/compass-3-fill.svg": 899579,
	"./RemixIcon/Map/compass-3-line.svg": 751957,
	"./RemixIcon/Map/compass-4-fill.svg": 975728,
	"./RemixIcon/Map/compass-4-line.svg": 393238,
	"./RemixIcon/Map/compass-discover-fill.svg": 156840,
	"./RemixIcon/Map/compass-discover-line.svg": 555904,
	"./RemixIcon/Map/compass-fill.svg": 550240,
	"./RemixIcon/Map/compass-line.svg": 412952,
	"./RemixIcon/Map/cup-fill.svg": 490538,
	"./RemixIcon/Map/cup-line.svg": 452039,
	"./RemixIcon/Map/direction-fill.svg": 290419,
	"./RemixIcon/Map/direction-line.svg": 402966,
	"./RemixIcon/Map/e-bike-2-fill.svg": 354869,
	"./RemixIcon/Map/e-bike-2-line.svg": 553487,
	"./RemixIcon/Map/e-bike-fill.svg": 96299,
	"./RemixIcon/Map/e-bike-line.svg": 478384,
	"./RemixIcon/Map/earth-fill.svg": 285764,
	"./RemixIcon/Map/earth-line.svg": 859139,
	"./RemixIcon/Map/flight-land-fill.svg": 988596,
	"./RemixIcon/Map/flight-land-line.svg": 352332,
	"./RemixIcon/Map/flight-takeoff-fill.svg": 21199,
	"./RemixIcon/Map/flight-takeoff-line.svg": 424233,
	"./RemixIcon/Map/footprint-fill.svg": 817808,
	"./RemixIcon/Map/footprint-line.svg": 388869,
	"./RemixIcon/Map/gas-station-fill.svg": 226665,
	"./RemixIcon/Map/gas-station-line.svg": 289705,
	"./RemixIcon/Map/globe-fill.svg": 495796,
	"./RemixIcon/Map/globe-line.svg": 426082,
	"./RemixIcon/Map/goblet-fill.svg": 565818,
	"./RemixIcon/Map/goblet-line.svg": 608422,
	"./RemixIcon/Map/guide-fill.svg": 852210,
	"./RemixIcon/Map/guide-line.svg": 401430,
	"./RemixIcon/Map/hotel-bed-fill.svg": 888393,
	"./RemixIcon/Map/hotel-bed-line.svg": 536934,
	"./RemixIcon/Map/lifebuoy-fill.svg": 607831,
	"./RemixIcon/Map/lifebuoy-line.svg": 85572,
	"./RemixIcon/Map/luggage-cart-fill.svg": 448235,
	"./RemixIcon/Map/luggage-cart-line.svg": 12437,
	"./RemixIcon/Map/luggage-deposit-fill.svg": 307714,
	"./RemixIcon/Map/luggage-deposit-line.svg": 890635,
	"./RemixIcon/Map/map-2-fill.svg": 116062,
	"./RemixIcon/Map/map-2-line.svg": 21524,
	"./RemixIcon/Map/map-fill.svg": 646602,
	"./RemixIcon/Map/map-line.svg": 865241,
	"./RemixIcon/Map/map-pin-2-fill.svg": 789824,
	"./RemixIcon/Map/map-pin-2-line.svg": 141471,
	"./RemixIcon/Map/map-pin-3-fill.svg": 332614,
	"./RemixIcon/Map/map-pin-3-line.svg": 857407,
	"./RemixIcon/Map/map-pin-4-fill.svg": 265750,
	"./RemixIcon/Map/map-pin-4-line.svg": 33744,
	"./RemixIcon/Map/map-pin-5-fill.svg": 336543,
	"./RemixIcon/Map/map-pin-5-line.svg": 824127,
	"./RemixIcon/Map/map-pin-add-fill.svg": 354129,
	"./RemixIcon/Map/map-pin-add-line.svg": 346000,
	"./RemixIcon/Map/map-pin-fill.svg": 629635,
	"./RemixIcon/Map/map-pin-line.svg": 619069,
	"./RemixIcon/Map/map-pin-range-fill.svg": 96906,
	"./RemixIcon/Map/map-pin-range-line.svg": 921722,
	"./RemixIcon/Map/map-pin-time-fill.svg": 618507,
	"./RemixIcon/Map/map-pin-time-line.svg": 838440,
	"./RemixIcon/Map/map-pin-user-fill.svg": 345484,
	"./RemixIcon/Map/map-pin-user-line.svg": 437378,
	"./RemixIcon/Map/motorbike-fill.svg": 531254,
	"./RemixIcon/Map/motorbike-line.svg": 543238,
	"./RemixIcon/Map/navigation-fill.svg": 727926,
	"./RemixIcon/Map/navigation-line.svg": 579619,
	"./RemixIcon/Map/oil-fill.svg": 588185,
	"./RemixIcon/Map/oil-line.svg": 639766,
	"./RemixIcon/Map/parking-box-fill.svg": 269503,
	"./RemixIcon/Map/parking-box-line.svg": 639547,
	"./RemixIcon/Map/parking-fill.svg": 897598,
	"./RemixIcon/Map/parking-line.svg": 65688,
	"./RemixIcon/Map/passport-fill.svg": 462138,
	"./RemixIcon/Map/passport-line.svg": 585811,
	"./RemixIcon/Map/pin-distance-fill.svg": 717279,
	"./RemixIcon/Map/pin-distance-line.svg": 628275,
	"./RemixIcon/Map/plane-fill.svg": 28332,
	"./RemixIcon/Map/plane-line.svg": 520995,
	"./RemixIcon/Map/police-car-fill.svg": 458031,
	"./RemixIcon/Map/police-car-line.svg": 937277,
	"./RemixIcon/Map/pushpin-2-fill.svg": 15396,
	"./RemixIcon/Map/pushpin-2-line.svg": 409417,
	"./RemixIcon/Map/pushpin-fill.svg": 626080,
	"./RemixIcon/Map/pushpin-line.svg": 830419,
	"./RemixIcon/Map/restaurant-2-fill.svg": 795178,
	"./RemixIcon/Map/restaurant-2-line.svg": 109127,
	"./RemixIcon/Map/restaurant-fill.svg": 204746,
	"./RemixIcon/Map/restaurant-line.svg": 444103,
	"./RemixIcon/Map/riding-fill.svg": 510821,
	"./RemixIcon/Map/riding-line.svg": 14940,
	"./RemixIcon/Map/road-map-fill.svg": 388015,
	"./RemixIcon/Map/road-map-line.svg": 607210,
	"./RemixIcon/Map/roadster-fill.svg": 692271,
	"./RemixIcon/Map/roadster-line.svg": 272000,
	"./RemixIcon/Map/rocket-2-fill.svg": 415538,
	"./RemixIcon/Map/rocket-2-line.svg": 927945,
	"./RemixIcon/Map/rocket-fill.svg": 99979,
	"./RemixIcon/Map/rocket-line.svg": 805446,
	"./RemixIcon/Map/route-fill.svg": 247896,
	"./RemixIcon/Map/route-line.svg": 265846,
	"./RemixIcon/Map/run-fill.svg": 18932,
	"./RemixIcon/Map/run-line.svg": 316805,
	"./RemixIcon/Map/sailboat-fill.svg": 552462,
	"./RemixIcon/Map/sailboat-line.svg": 602523,
	"./RemixIcon/Map/ship-2-fill.svg": 708894,
	"./RemixIcon/Map/ship-2-line.svg": 881456,
	"./RemixIcon/Map/ship-fill.svg": 785605,
	"./RemixIcon/Map/ship-line.svg": 59108,
	"./RemixIcon/Map/signal-tower-fill.svg": 794207,
	"./RemixIcon/Map/signal-tower-line.svg": 773663,
	"./RemixIcon/Map/space-ship-fill.svg": 289264,
	"./RemixIcon/Map/space-ship-line.svg": 227479,
	"./RemixIcon/Map/steering-2-fill.svg": 691630,
	"./RemixIcon/Map/steering-2-line.svg": 293491,
	"./RemixIcon/Map/steering-fill.svg": 886881,
	"./RemixIcon/Map/steering-line.svg": 270859,
	"./RemixIcon/Map/subway-fill.svg": 973726,
	"./RemixIcon/Map/subway-line.svg": 434384,
	"./RemixIcon/Map/subway-wifi-fill.svg": 95851,
	"./RemixIcon/Map/subway-wifi-line.svg": 729781,
	"./RemixIcon/Map/suitcase-2-fill.svg": 282960,
	"./RemixIcon/Map/suitcase-2-line.svg": 871815,
	"./RemixIcon/Map/suitcase-3-fill.svg": 883210,
	"./RemixIcon/Map/suitcase-3-line.svg": 620994,
	"./RemixIcon/Map/suitcase-fill.svg": 263522,
	"./RemixIcon/Map/suitcase-line.svg": 616404,
	"./RemixIcon/Map/takeaway-fill.svg": 323897,
	"./RemixIcon/Map/takeaway-line.svg": 294858,
	"./RemixIcon/Map/taxi-fill.svg": 741422,
	"./RemixIcon/Map/taxi-line.svg": 42805,
	"./RemixIcon/Map/taxi-wifi-fill.svg": 871329,
	"./RemixIcon/Map/taxi-wifi-line.svg": 873046,
	"./RemixIcon/Map/traffic-light-fill.svg": 16618,
	"./RemixIcon/Map/traffic-light-line.svg": 301793,
	"./RemixIcon/Map/train-fill.svg": 56390,
	"./RemixIcon/Map/train-line.svg": 132434,
	"./RemixIcon/Map/train-wifi-fill.svg": 309687,
	"./RemixIcon/Map/train-wifi-line.svg": 171790,
	"./RemixIcon/Map/treasure-map-fill.svg": 2115,
	"./RemixIcon/Map/treasure-map-line.svg": 114085,
	"./RemixIcon/Map/truck-fill.svg": 713534,
	"./RemixIcon/Map/truck-line.svg": 324571,
	"./RemixIcon/Map/walk-fill.svg": 890486,
	"./RemixIcon/Map/walk-line.svg": 440687,
	"./RemixIcon/Media/4k-fill.svg": 194479,
	"./RemixIcon/Media/4k-line.svg": 197427,
	"./RemixIcon/Media/album-fill.svg": 293044,
	"./RemixIcon/Media/album-line.svg": 550219,
	"./RemixIcon/Media/aspect-ratio-fill.svg": 909903,
	"./RemixIcon/Media/aspect-ratio-line.svg": 542592,
	"./RemixIcon/Media/broadcast-fill.svg": 373866,
	"./RemixIcon/Media/broadcast-line.svg": 488525,
	"./RemixIcon/Media/camera-2-fill.svg": 801021,
	"./RemixIcon/Media/camera-2-line.svg": 213510,
	"./RemixIcon/Media/camera-3-fill.svg": 658422,
	"./RemixIcon/Media/camera-3-line.svg": 959461,
	"./RemixIcon/Media/camera-fill.svg": 131670,
	"./RemixIcon/Media/camera-lens-fill.svg": 250465,
	"./RemixIcon/Media/camera-lens-line.svg": 996447,
	"./RemixIcon/Media/camera-line.svg": 743109,
	"./RemixIcon/Media/camera-off-fill.svg": 387736,
	"./RemixIcon/Media/camera-off-line.svg": 70583,
	"./RemixIcon/Media/camera-switch-fill.svg": 297397,
	"./RemixIcon/Media/camera-switch-line.svg": 929286,
	"./RemixIcon/Media/clapperboard-fill.svg": 13038,
	"./RemixIcon/Media/clapperboard-line.svg": 524742,
	"./RemixIcon/Media/closed-captioning-fill.svg": 309781,
	"./RemixIcon/Media/closed-captioning-line.svg": 829144,
	"./RemixIcon/Media/disc-fill.svg": 528417,
	"./RemixIcon/Media/disc-line.svg": 778475,
	"./RemixIcon/Media/dv-fill.svg": 163444,
	"./RemixIcon/Media/dv-line.svg": 122228,
	"./RemixIcon/Media/dvd-fill.svg": 463904,
	"./RemixIcon/Media/dvd-line.svg": 807154,
	"./RemixIcon/Media/eject-fill.svg": 586064,
	"./RemixIcon/Media/eject-line.svg": 228888,
	"./RemixIcon/Media/equalizer-fill.svg": 368804,
	"./RemixIcon/Media/equalizer-line.svg": 354305,
	"./RemixIcon/Media/film-fill.svg": 124345,
	"./RemixIcon/Media/film-line.svg": 615401,
	"./RemixIcon/Media/fullscreen-exit-fill.svg": 955790,
	"./RemixIcon/Media/fullscreen-exit-line.svg": 680316,
	"./RemixIcon/Media/fullscreen-fill.svg": 310491,
	"./RemixIcon/Media/fullscreen-line.svg": 303948,
	"./RemixIcon/Media/gallery-fill.svg": 202790,
	"./RemixIcon/Media/gallery-line.svg": 23900,
	"./RemixIcon/Media/gallery-upload-fill.svg": 115527,
	"./RemixIcon/Media/gallery-upload-line.svg": 531341,
	"./RemixIcon/Media/hd-fill.svg": 128992,
	"./RemixIcon/Media/hd-line.svg": 371273,
	"./RemixIcon/Media/headphone-fill.svg": 389940,
	"./RemixIcon/Media/headphone-line.svg": 516724,
	"./RemixIcon/Media/hq-fill.svg": 723703,
	"./RemixIcon/Media/hq-line.svg": 368098,
	"./RemixIcon/Media/image-2-fill.svg": 30983,
	"./RemixIcon/Media/image-2-line.svg": 328288,
	"./RemixIcon/Media/image-add-fill.svg": 582943,
	"./RemixIcon/Media/image-add-line.svg": 979730,
	"./RemixIcon/Media/image-edit-fill.svg": 941674,
	"./RemixIcon/Media/image-edit-line.svg": 129360,
	"./RemixIcon/Media/image-fill.svg": 730477,
	"./RemixIcon/Media/image-line.svg": 19148,
	"./RemixIcon/Media/landscape-fill.svg": 369232,
	"./RemixIcon/Media/landscape-line.svg": 299916,
	"./RemixIcon/Media/live-fill.svg": 437061,
	"./RemixIcon/Media/live-line.svg": 717744,
	"./RemixIcon/Media/mic-2-fill.svg": 595052,
	"./RemixIcon/Media/mic-2-line.svg": 717037,
	"./RemixIcon/Media/mic-fill.svg": 3238,
	"./RemixIcon/Media/mic-line.svg": 285206,
	"./RemixIcon/Media/mic-off-fill.svg": 827464,
	"./RemixIcon/Media/mic-off-line.svg": 403369,
	"./RemixIcon/Media/movie-2-fill.svg": 450646,
	"./RemixIcon/Media/movie-2-line.svg": 656308,
	"./RemixIcon/Media/movie-fill.svg": 411714,
	"./RemixIcon/Media/movie-line.svg": 121567,
	"./RemixIcon/Media/music-2-fill.svg": 119298,
	"./RemixIcon/Media/music-2-line.svg": 282036,
	"./RemixIcon/Media/music-fill.svg": 560665,
	"./RemixIcon/Media/music-line.svg": 533535,
	"./RemixIcon/Media/mv-fill.svg": 264088,
	"./RemixIcon/Media/mv-line.svg": 186841,
	"./RemixIcon/Media/notification-2-fill.svg": 72133,
	"./RemixIcon/Media/notification-2-line.svg": 164041,
	"./RemixIcon/Media/notification-3-fill.svg": 644440,
	"./RemixIcon/Media/notification-3-line.svg": 966794,
	"./RemixIcon/Media/notification-4-fill.svg": 685914,
	"./RemixIcon/Media/notification-4-line.svg": 988474,
	"./RemixIcon/Media/notification-fill.svg": 647687,
	"./RemixIcon/Media/notification-line.svg": 573525,
	"./RemixIcon/Media/notification-off-fill.svg": 749163,
	"./RemixIcon/Media/notification-off-line.svg": 411321,
	"./RemixIcon/Media/order-play-fill.svg": 911883,
	"./RemixIcon/Media/order-play-line.svg": 347077,
	"./RemixIcon/Media/pause-circle-fill.svg": 854529,
	"./RemixIcon/Media/pause-circle-line.svg": 942340,
	"./RemixIcon/Media/pause-fill.svg": 932828,
	"./RemixIcon/Media/pause-line.svg": 500262,
	"./RemixIcon/Media/pause-mini-fill.svg": 296344,
	"./RemixIcon/Media/pause-mini-line.svg": 257092,
	"./RemixIcon/Media/phone-camera-fill.svg": 236625,
	"./RemixIcon/Media/phone-camera-line.svg": 851197,
	"./RemixIcon/Media/picture-in-picture-2-fill.svg": 154939,
	"./RemixIcon/Media/picture-in-picture-2-line.svg": 582905,
	"./RemixIcon/Media/picture-in-picture-exit-fill.svg": 38699,
	"./RemixIcon/Media/picture-in-picture-exit-line.svg": 593124,
	"./RemixIcon/Media/picture-in-picture-fill.svg": 537641,
	"./RemixIcon/Media/picture-in-picture-line.svg": 965269,
	"./RemixIcon/Media/play-circle-fill.svg": 146777,
	"./RemixIcon/Media/play-circle-line.svg": 202561,
	"./RemixIcon/Media/play-fill.svg": 497395,
	"./RemixIcon/Media/play-line.svg": 388003,
	"./RemixIcon/Media/play-list-2-fill.svg": 682326,
	"./RemixIcon/Media/play-list-2-line.svg": 724906,
	"./RemixIcon/Media/play-list-add-fill.svg": 960575,
	"./RemixIcon/Media/play-list-add-line.svg": 449997,
	"./RemixIcon/Media/play-list-fill.svg": 120670,
	"./RemixIcon/Media/play-list-line.svg": 917393,
	"./RemixIcon/Media/play-mini-fill.svg": 565446,
	"./RemixIcon/Media/play-mini-line.svg": 682414,
	"./RemixIcon/Media/polaroid-2-fill.svg": 492784,
	"./RemixIcon/Media/polaroid-2-line.svg": 258585,
	"./RemixIcon/Media/polaroid-fill.svg": 473799,
	"./RemixIcon/Media/polaroid-line.svg": 342861,
	"./RemixIcon/Media/radio-2-fill.svg": 783024,
	"./RemixIcon/Media/radio-2-line.svg": 158573,
	"./RemixIcon/Media/radio-fill.svg": 234536,
	"./RemixIcon/Media/radio-line.svg": 302870,
	"./RemixIcon/Media/record-circle-fill.svg": 630273,
	"./RemixIcon/Media/record-circle-line.svg": 157428,
	"./RemixIcon/Media/repeat-2-fill.svg": 112002,
	"./RemixIcon/Media/repeat-2-line.svg": 702119,
	"./RemixIcon/Media/repeat-fill.svg": 694698,
	"./RemixIcon/Media/repeat-line.svg": 979699,
	"./RemixIcon/Media/repeat-one-fill.svg": 730108,
	"./RemixIcon/Media/repeat-one-line.svg": 338788,
	"./RemixIcon/Media/rewind-fill.svg": 782577,
	"./RemixIcon/Media/rewind-line.svg": 657991,
	"./RemixIcon/Media/rewind-mini-fill.svg": 997226,
	"./RemixIcon/Media/rewind-mini-line.svg": 434642,
	"./RemixIcon/Media/rhythm-fill.svg": 348102,
	"./RemixIcon/Media/rhythm-line.svg": 12963,
	"./RemixIcon/Media/shuffle-fill.svg": 53181,
	"./RemixIcon/Media/shuffle-line.svg": 680495,
	"./RemixIcon/Media/skip-back-fill.svg": 859645,
	"./RemixIcon/Media/skip-back-line.svg": 328641,
	"./RemixIcon/Media/skip-back-mini-fill.svg": 42843,
	"./RemixIcon/Media/skip-back-mini-line.svg": 415390,
	"./RemixIcon/Media/skip-forward-fill.svg": 25519,
	"./RemixIcon/Media/skip-forward-line.svg": 577281,
	"./RemixIcon/Media/skip-forward-mini-fill.svg": 307455,
	"./RemixIcon/Media/skip-forward-mini-line.svg": 705106,
	"./RemixIcon/Media/sound-module-fill.svg": 319336,
	"./RemixIcon/Media/sound-module-line.svg": 99218,
	"./RemixIcon/Media/speaker-2-fill.svg": 793951,
	"./RemixIcon/Media/speaker-2-line.svg": 231389,
	"./RemixIcon/Media/speaker-3-fill.svg": 1811,
	"./RemixIcon/Media/speaker-3-line.svg": 946099,
	"./RemixIcon/Media/speaker-fill.svg": 521026,
	"./RemixIcon/Media/speaker-line.svg": 396042,
	"./RemixIcon/Media/speed-fill.svg": 577243,
	"./RemixIcon/Media/speed-line.svg": 11689,
	"./RemixIcon/Media/speed-mini-fill.svg": 164322,
	"./RemixIcon/Media/speed-mini-line.svg": 276489,
	"./RemixIcon/Media/stop-circle-fill.svg": 712530,
	"./RemixIcon/Media/stop-circle-line.svg": 984768,
	"./RemixIcon/Media/stop-fill.svg": 761518,
	"./RemixIcon/Media/stop-line.svg": 618675,
	"./RemixIcon/Media/stop-mini-fill.svg": 259410,
	"./RemixIcon/Media/stop-mini-line.svg": 878992,
	"./RemixIcon/Media/surround-sound-fill.svg": 58911,
	"./RemixIcon/Media/surround-sound-line.svg": 842626,
	"./RemixIcon/Media/tape-fill.svg": 934835,
	"./RemixIcon/Media/tape-line.svg": 929874,
	"./RemixIcon/Media/video-add-fill.svg": 819274,
	"./RemixIcon/Media/video-add-line.svg": 612533,
	"./RemixIcon/Media/video-download-fill.svg": 471210,
	"./RemixIcon/Media/video-download-line.svg": 712292,
	"./RemixIcon/Media/video-fill.svg": 238169,
	"./RemixIcon/Media/video-line.svg": 116485,
	"./RemixIcon/Media/video-upload-fill.svg": 313206,
	"./RemixIcon/Media/video-upload-line.svg": 393605,
	"./RemixIcon/Media/vidicon-2-fill.svg": 890032,
	"./RemixIcon/Media/vidicon-2-line.svg": 321181,
	"./RemixIcon/Media/vidicon-fill.svg": 914321,
	"./RemixIcon/Media/vidicon-line.svg": 751060,
	"./RemixIcon/Media/voiceprint-fill.svg": 699727,
	"./RemixIcon/Media/voiceprint-line.svg": 114456,
	"./RemixIcon/Media/volume-down-fill.svg": 306641,
	"./RemixIcon/Media/volume-down-line.svg": 214284,
	"./RemixIcon/Media/volume-mute-fill.svg": 872227,
	"./RemixIcon/Media/volume-mute-line.svg": 922258,
	"./RemixIcon/Media/volume-off-vibrate-fill.svg": 180054,
	"./RemixIcon/Media/volume-off-vibrate-line.svg": 601523,
	"./RemixIcon/Media/volume-up-fill.svg": 34037,
	"./RemixIcon/Media/volume-up-line.svg": 715379,
	"./RemixIcon/Media/volume-vibrate-fill.svg": 517827,
	"./RemixIcon/Media/volume-vibrate-line.svg": 696067,
	"./RemixIcon/Media/webcam-fill.svg": 134792,
	"./RemixIcon/Media/webcam-line.svg": 120973,
	"./RemixIcon/Others/basketball-fill.svg": 406909,
	"./RemixIcon/Others/basketball-line.svg": 68812,
	"./RemixIcon/Others/bell-fill.svg": 31884,
	"./RemixIcon/Others/bell-line.svg": 984581,
	"./RemixIcon/Others/billiards-fill.svg": 743152,
	"./RemixIcon/Others/billiards-line.svg": 461137,
	"./RemixIcon/Others/boxing-fill.svg": 323073,
	"./RemixIcon/Others/boxing-line.svg": 863576,
	"./RemixIcon/Others/cactus-fill.svg": 729513,
	"./RemixIcon/Others/cactus-line.svg": 907462,
	"./RemixIcon/Others/cake-2-fill.svg": 830499,
	"./RemixIcon/Others/cake-2-line.svg": 869868,
	"./RemixIcon/Others/cake-3-fill.svg": 272531,
	"./RemixIcon/Others/cake-3-line.svg": 19370,
	"./RemixIcon/Others/cake-fill.svg": 531555,
	"./RemixIcon/Others/cake-line.svg": 357254,
	"./RemixIcon/Others/character-recognition-fill.svg": 544215,
	"./RemixIcon/Others/character-recognition-line.svg": 940362,
	"./RemixIcon/Others/door-closed-fill.svg": 953131,
	"./RemixIcon/Others/door-closed-line.svg": 78890,
	"./RemixIcon/Others/door-fill.svg": 252146,
	"./RemixIcon/Others/door-line.svg": 974653,
	"./RemixIcon/Others/door-lock-box-fill.svg": 329931,
	"./RemixIcon/Others/door-lock-box-line.svg": 772986,
	"./RemixIcon/Others/door-lock-fill.svg": 710810,
	"./RemixIcon/Others/door-lock-line.svg": 227201,
	"./RemixIcon/Others/door-open-fill.svg": 836123,
	"./RemixIcon/Others/door-open-line.svg": 554357,
	"./RemixIcon/Others/football-fill.svg": 257546,
	"./RemixIcon/Others/football-line.svg": 702704,
	"./RemixIcon/Others/fridge-fill.svg": 320206,
	"./RemixIcon/Others/fridge-line.svg": 691330,
	"./RemixIcon/Others/game-fill.svg": 583416,
	"./RemixIcon/Others/game-line.svg": 152741,
	"./RemixIcon/Others/handbag-fill.svg": 462547,
	"./RemixIcon/Others/handbag-line.svg": 485833,
	"./RemixIcon/Others/key-2-fill.svg": 691864,
	"./RemixIcon/Others/key-2-line.svg": 798193,
	"./RemixIcon/Others/key-fill.svg": 628000,
	"./RemixIcon/Others/key-line.svg": 13904,
	"./RemixIcon/Others/knife-blood-fill.svg": 754276,
	"./RemixIcon/Others/knife-blood-line.svg": 323481,
	"./RemixIcon/Others/knife-fill.svg": 277020,
	"./RemixIcon/Others/knife-line.svg": 506518,
	"./RemixIcon/Others/leaf-fill.svg": 515492,
	"./RemixIcon/Others/leaf-line.svg": 227311,
	"./RemixIcon/Others/lightbulb-fill.svg": 762350,
	"./RemixIcon/Others/lightbulb-flash-fill.svg": 32940,
	"./RemixIcon/Others/lightbulb-flash-line.svg": 359119,
	"./RemixIcon/Others/lightbulb-line.svg": 604793,
	"./RemixIcon/Others/outlet-2-fill.svg": 652155,
	"./RemixIcon/Others/outlet-2-line.svg": 253418,
	"./RemixIcon/Others/outlet-fill.svg": 538573,
	"./RemixIcon/Others/outlet-line.svg": 697692,
	"./RemixIcon/Others/ping-pong-fill.svg": 591924,
	"./RemixIcon/Others/ping-pong-line.svg": 800313,
	"./RemixIcon/Others/plant-fill.svg": 440162,
	"./RemixIcon/Others/plant-line.svg": 882860,
	"./RemixIcon/Others/plug-2-fill.svg": 249785,
	"./RemixIcon/Others/plug-2-line.svg": 394562,
	"./RemixIcon/Others/plug-fill.svg": 889961,
	"./RemixIcon/Others/plug-line.svg": 928638,
	"./RemixIcon/Others/recycle-fill.svg": 429688,
	"./RemixIcon/Others/recycle-line.svg": 970116,
	"./RemixIcon/Others/reserved-fill.svg": 239679,
	"./RemixIcon/Others/reserved-line.svg": 148027,
	"./RemixIcon/Others/scales-2-fill.svg": 45037,
	"./RemixIcon/Others/scales-2-line.svg": 297790,
	"./RemixIcon/Others/scales-3-fill.svg": 148610,
	"./RemixIcon/Others/scales-3-line.svg": 202930,
	"./RemixIcon/Others/scales-fill.svg": 686998,
	"./RemixIcon/Others/scales-line.svg": 787224,
	"./RemixIcon/Others/seedling-fill.svg": 158214,
	"./RemixIcon/Others/seedling-line.svg": 278373,
	"./RemixIcon/Others/shirt-fill.svg": 933393,
	"./RemixIcon/Others/shirt-line.svg": 859222,
	"./RemixIcon/Others/sword-fill.svg": 629187,
	"./RemixIcon/Others/sword-line.svg": 670972,
	"./RemixIcon/Others/t-shirt-2-fill.svg": 72469,
	"./RemixIcon/Others/t-shirt-2-line.svg": 495804,
	"./RemixIcon/Others/t-shirt-air-fill.svg": 939730,
	"./RemixIcon/Others/t-shirt-air-line.svg": 704907,
	"./RemixIcon/Others/t-shirt-fill.svg": 458518,
	"./RemixIcon/Others/t-shirt-line.svg": 165692,
	"./RemixIcon/Others/umbrella-fill.svg": 37038,
	"./RemixIcon/Others/umbrella-line.svg": 514477,
	"./RemixIcon/Others/voice-recognition-fill.svg": 843303,
	"./RemixIcon/Others/voice-recognition-line.svg": 478228,
	"./RemixIcon/Others/wheelchair-fill.svg": 748557,
	"./RemixIcon/Others/wheelchair-line.svg": 41359,
	"./RemixIcon/System/add-box-fill.svg": 34430,
	"./RemixIcon/System/add-box-line.svg": 353071,
	"./RemixIcon/System/add-circle-fill.svg": 343852,
	"./RemixIcon/System/add-circle-line.svg": 248291,
	"./RemixIcon/System/add-fill.svg": 393820,
	"./RemixIcon/System/add-line.svg": 911958,
	"./RemixIcon/System/alarm-fill.svg": 237623,
	"./RemixIcon/System/alarm-line.svg": 327941,
	"./RemixIcon/System/alarm-warning-fill.svg": 437,
	"./RemixIcon/System/alarm-warning-line.svg": 703666,
	"./RemixIcon/System/alert-fill.svg": 844745,
	"./RemixIcon/System/alert-line.svg": 949002,
	"./RemixIcon/System/apps-2-fill.svg": 575147,
	"./RemixIcon/System/apps-2-line.svg": 406315,
	"./RemixIcon/System/apps-fill.svg": 26045,
	"./RemixIcon/System/apps-line.svg": 56870,
	"./RemixIcon/System/arrow-down-circle-fill.svg": 505079,
	"./RemixIcon/System/arrow-down-circle-line.svg": 291285,
	"./RemixIcon/System/arrow-down-fill.svg": 418918,
	"./RemixIcon/System/arrow-down-line.svg": 787500,
	"./RemixIcon/System/arrow-down-s-fill.svg": 697545,
	"./RemixIcon/System/arrow-down-s-line.svg": 817197,
	"./RemixIcon/System/arrow-drop-down-fill.svg": 628339,
	"./RemixIcon/System/arrow-drop-down-line.svg": 159738,
	"./RemixIcon/System/arrow-drop-left-fill.svg": 934478,
	"./RemixIcon/System/arrow-drop-left-line.svg": 194882,
	"./RemixIcon/System/arrow-drop-right-fill.svg": 916580,
	"./RemixIcon/System/arrow-drop-right-line.svg": 153562,
	"./RemixIcon/System/arrow-drop-up-fill.svg": 90632,
	"./RemixIcon/System/arrow-drop-up-line.svg": 383094,
	"./RemixIcon/System/arrow-go-back-fill.svg": 438405,
	"./RemixIcon/System/arrow-go-back-line.svg": 996694,
	"./RemixIcon/System/arrow-go-forward-fill.svg": 269197,
	"./RemixIcon/System/arrow-go-forward-line.svg": 66747,
	"./RemixIcon/System/arrow-left-circle-fill.svg": 574133,
	"./RemixIcon/System/arrow-left-circle-line.svg": 708508,
	"./RemixIcon/System/arrow-left-down-fill.svg": 454348,
	"./RemixIcon/System/arrow-left-down-line.svg": 697141,
	"./RemixIcon/System/arrow-left-fill.svg": 1091,
	"./RemixIcon/System/arrow-left-line.svg": 938888,
	"./RemixIcon/System/arrow-left-right-fill.svg": 112009,
	"./RemixIcon/System/arrow-left-right-line.svg": 512420,
	"./RemixIcon/System/arrow-left-s-fill.svg": 815353,
	"./RemixIcon/System/arrow-left-s-line.svg": 972994,
	"./RemixIcon/System/arrow-left-up-fill.svg": 588555,
	"./RemixIcon/System/arrow-left-up-line.svg": 990722,
	"./RemixIcon/System/arrow-right-circle-fill.svg": 463807,
	"./RemixIcon/System/arrow-right-circle-line.svg": 893155,
	"./RemixIcon/System/arrow-right-down-fill.svg": 650146,
	"./RemixIcon/System/arrow-right-down-line.svg": 240430,
	"./RemixIcon/System/arrow-right-fill.svg": 229799,
	"./RemixIcon/System/arrow-right-line.svg": 756933,
	"./RemixIcon/System/arrow-right-s-fill.svg": 737945,
	"./RemixIcon/System/arrow-right-s-line.svg": 495023,
	"./RemixIcon/System/arrow-right-up-fill.svg": 807165,
	"./RemixIcon/System/arrow-right-up-line.svg": 313760,
	"./RemixIcon/System/arrow-up-circle-fill.svg": 545039,
	"./RemixIcon/System/arrow-up-circle-line.svg": 123137,
	"./RemixIcon/System/arrow-up-down-fill.svg": 656386,
	"./RemixIcon/System/arrow-up-down-line.svg": 123961,
	"./RemixIcon/System/arrow-up-fill.svg": 590609,
	"./RemixIcon/System/arrow-up-line.svg": 555622,
	"./RemixIcon/System/arrow-up-s-fill.svg": 183506,
	"./RemixIcon/System/arrow-up-s-line.svg": 395006,
	"./RemixIcon/System/check-double-fill.svg": 830880,
	"./RemixIcon/System/check-double-line.svg": 6751,
	"./RemixIcon/System/check-fill.svg": 13083,
	"./RemixIcon/System/check-line.svg": 338938,
	"./RemixIcon/System/checkbox-blank-circle-fill.svg": 843972,
	"./RemixIcon/System/checkbox-blank-circle-line.svg": 539198,
	"./RemixIcon/System/checkbox-blank-fill.svg": 308522,
	"./RemixIcon/System/checkbox-blank-line.svg": 24712,
	"./RemixIcon/System/checkbox-circle-fill.svg": 770630,
	"./RemixIcon/System/checkbox-circle-line.svg": 490371,
	"./RemixIcon/System/checkbox-fill.svg": 716624,
	"./RemixIcon/System/checkbox-indeterminate-fill.svg": 974302,
	"./RemixIcon/System/checkbox-indeterminate-line.svg": 604650,
	"./RemixIcon/System/checkbox-line.svg": 573706,
	"./RemixIcon/System/checkbox-multiple-blank-fill.svg": 97639,
	"./RemixIcon/System/checkbox-multiple-blank-line.svg": 4894,
	"./RemixIcon/System/checkbox-multiple-fill.svg": 612156,
	"./RemixIcon/System/checkbox-multiple-line.svg": 281328,
	"./RemixIcon/System/close-circle-fill.svg": 780780,
	"./RemixIcon/System/close-circle-line.svg": 171032,
	"./RemixIcon/System/close-fill.svg": 944961,
	"./RemixIcon/System/close-line.svg": 260960,
	"./RemixIcon/System/dashboard-fill.svg": 986866,
	"./RemixIcon/System/dashboard-line.svg": 192287,
	"./RemixIcon/System/delete-back-2-fill.svg": 792392,
	"./RemixIcon/System/delete-back-2-line.svg": 12455,
	"./RemixIcon/System/delete-back-fill.svg": 608972,
	"./RemixIcon/System/delete-back-line.svg": 173810,
	"./RemixIcon/System/delete-bin-2-fill.svg": 518575,
	"./RemixIcon/System/delete-bin-2-line.svg": 276467,
	"./RemixIcon/System/delete-bin-3-fill.svg": 64469,
	"./RemixIcon/System/delete-bin-3-line.svg": 578089,
	"./RemixIcon/System/delete-bin-4-fill.svg": 187093,
	"./RemixIcon/System/delete-bin-4-line.svg": 8072,
	"./RemixIcon/System/delete-bin-5-fill.svg": 4840,
	"./RemixIcon/System/delete-bin-5-line.svg": 718579,
	"./RemixIcon/System/delete-bin-6-fill.svg": 108587,
	"./RemixIcon/System/delete-bin-6-line.svg": 80405,
	"./RemixIcon/System/delete-bin-7-fill.svg": 428587,
	"./RemixIcon/System/delete-bin-7-line.svg": 47602,
	"./RemixIcon/System/delete-bin-fill.svg": 544990,
	"./RemixIcon/System/delete-bin-line.svg": 630652,
	"./RemixIcon/System/divide-fill.svg": 701179,
	"./RemixIcon/System/divide-line.svg": 630100,
	"./RemixIcon/System/download-2-fill.svg": 308978,
	"./RemixIcon/System/download-2-line.svg": 690649,
	"./RemixIcon/System/download-cloud-2-fill.svg": 479563,
	"./RemixIcon/System/download-cloud-2-line.svg": 73268,
	"./RemixIcon/System/download-cloud-fill.svg": 12219,
	"./RemixIcon/System/download-cloud-line.svg": 326650,
	"./RemixIcon/System/download-fill.svg": 662623,
	"./RemixIcon/System/download-line.svg": 137473,
	"./RemixIcon/System/error-warning-fill.svg": 512849,
	"./RemixIcon/System/error-warning-line.svg": 440965,
	"./RemixIcon/System/external-link-fill.svg": 85984,
	"./RemixIcon/System/external-link-line.svg": 306385,
	"./RemixIcon/System/eye-2-fill.svg": 151664,
	"./RemixIcon/System/eye-2-line.svg": 408553,
	"./RemixIcon/System/eye-close-fill.svg": 905794,
	"./RemixIcon/System/eye-close-line.svg": 157279,
	"./RemixIcon/System/eye-fill.svg": 723326,
	"./RemixIcon/System/eye-line.svg": 920674,
	"./RemixIcon/System/eye-off-fill.svg": 528733,
	"./RemixIcon/System/eye-off-line.svg": 679657,
	"./RemixIcon/System/filter-2-fill.svg": 645077,
	"./RemixIcon/System/filter-2-line.svg": 551291,
	"./RemixIcon/System/filter-3-fill.svg": 4646,
	"./RemixIcon/System/filter-3-line.svg": 640814,
	"./RemixIcon/System/filter-fill.svg": 359318,
	"./RemixIcon/System/filter-line.svg": 232490,
	"./RemixIcon/System/filter-off-fill.svg": 576172,
	"./RemixIcon/System/filter-off-line.svg": 556794,
	"./RemixIcon/System/find-replace-fill.svg": 547540,
	"./RemixIcon/System/find-replace-line.svg": 463381,
	"./RemixIcon/System/forbid-2-fill.svg": 720107,
	"./RemixIcon/System/forbid-2-line.svg": 993992,
	"./RemixIcon/System/forbid-fill.svg": 817092,
	"./RemixIcon/System/forbid-line.svg": 521985,
	"./RemixIcon/System/function-fill.svg": 686872,
	"./RemixIcon/System/function-line.svg": 942616,
	"./RemixIcon/System/history-fill.svg": 320280,
	"./RemixIcon/System/history-line.svg": 156606,
	"./RemixIcon/System/indeterminate-circle-fill.svg": 734310,
	"./RemixIcon/System/indeterminate-circle-line.svg": 390981,
	"./RemixIcon/System/information-fill.svg": 256594,
	"./RemixIcon/System/information-line.svg": 2345,
	"./RemixIcon/System/list-settings-fill.svg": 879312,
	"./RemixIcon/System/list-settings-line.svg": 379980,
	"./RemixIcon/System/loader-2-fill.svg": 659711,
	"./RemixIcon/System/loader-2-line.svg": 250433,
	"./RemixIcon/System/loader-3-fill.svg": 45075,
	"./RemixIcon/System/loader-3-line.svg": 741529,
	"./RemixIcon/System/loader-4-fill.svg": 439386,
	"./RemixIcon/System/loader-4-line.svg": 985315,
	"./RemixIcon/System/loader-5-fill.svg": 516595,
	"./RemixIcon/System/loader-5-line.svg": 466472,
	"./RemixIcon/System/loader-fill.svg": 677989,
	"./RemixIcon/System/loader-line.svg": 76135,
	"./RemixIcon/System/lock-2-fill.svg": 476987,
	"./RemixIcon/System/lock-2-line.svg": 592483,
	"./RemixIcon/System/lock-fill.svg": 629158,
	"./RemixIcon/System/lock-line.svg": 497705,
	"./RemixIcon/System/lock-password-fill.svg": 772191,
	"./RemixIcon/System/lock-password-line.svg": 565856,
	"./RemixIcon/System/lock-unlock-fill.svg": 690120,
	"./RemixIcon/System/lock-unlock-line.svg": 873762,
	"./RemixIcon/System/login-box-fill.svg": 733551,
	"./RemixIcon/System/login-box-line.svg": 957760,
	"./RemixIcon/System/login-circle-fill.svg": 382873,
	"./RemixIcon/System/login-circle-line.svg": 883049,
	"./RemixIcon/System/logout-box-fill.svg": 497029,
	"./RemixIcon/System/logout-box-line.svg": 504912,
	"./RemixIcon/System/logout-box-r-fill.svg": 71728,
	"./RemixIcon/System/logout-box-r-line.svg": 404613,
	"./RemixIcon/System/logout-circle-fill.svg": 782726,
	"./RemixIcon/System/logout-circle-line.svg": 72030,
	"./RemixIcon/System/logout-circle-r-fill.svg": 428983,
	"./RemixIcon/System/logout-circle-r-line.svg": 34933,
	"./RemixIcon/System/menu-2-fill.svg": 222162,
	"./RemixIcon/System/menu-2-line.svg": 192981,
	"./RemixIcon/System/menu-3-fill.svg": 857034,
	"./RemixIcon/System/menu-3-line.svg": 205696,
	"./RemixIcon/System/menu-4-fill.svg": 785930,
	"./RemixIcon/System/menu-4-line.svg": 376966,
	"./RemixIcon/System/menu-5-fill.svg": 793018,
	"./RemixIcon/System/menu-5-line.svg": 816844,
	"./RemixIcon/System/menu-add-fill.svg": 126506,
	"./RemixIcon/System/menu-add-line.svg": 658245,
	"./RemixIcon/System/menu-fill.svg": 528421,
	"./RemixIcon/System/menu-fold-fill.svg": 191474,
	"./RemixIcon/System/menu-fold-line.svg": 13585,
	"./RemixIcon/System/menu-line.svg": 110117,
	"./RemixIcon/System/menu-unfold-fill.svg": 668400,
	"./RemixIcon/System/menu-unfold-line.svg": 789054,
	"./RemixIcon/System/more-2-fill.svg": 310875,
	"./RemixIcon/System/more-2-line.svg": 691731,
	"./RemixIcon/System/more-fill.svg": 769313,
	"./RemixIcon/System/more-line.svg": 42822,
	"./RemixIcon/System/notification-badge-fill.svg": 766114,
	"./RemixIcon/System/notification-badge-line.svg": 499155,
	"./RemixIcon/System/question-fill.svg": 300087,
	"./RemixIcon/System/question-line.svg": 502233,
	"./RemixIcon/System/radio-button-fill.svg": 355212,
	"./RemixIcon/System/radio-button-line.svg": 245322,
	"./RemixIcon/System/refresh-fill.svg": 893238,
	"./RemixIcon/System/refresh-line.svg": 399325,
	"./RemixIcon/System/search-2-fill.svg": 710140,
	"./RemixIcon/System/search-2-line.svg": 898081,
	"./RemixIcon/System/search-eye-fill.svg": 751913,
	"./RemixIcon/System/search-eye-line.svg": 913607,
	"./RemixIcon/System/search-fill.svg": 729523,
	"./RemixIcon/System/search-line.svg": 490450,
	"./RemixIcon/System/settings-2-fill.svg": 36146,
	"./RemixIcon/System/settings-2-line.svg": 724736,
	"./RemixIcon/System/settings-3-fill.svg": 752985,
	"./RemixIcon/System/settings-3-line.svg": 319812,
	"./RemixIcon/System/settings-4-fill.svg": 783576,
	"./RemixIcon/System/settings-4-line.svg": 170793,
	"./RemixIcon/System/settings-5-fill.svg": 409918,
	"./RemixIcon/System/settings-5-line.svg": 444039,
	"./RemixIcon/System/settings-6-fill.svg": 630651,
	"./RemixIcon/System/settings-6-line.svg": 352095,
	"./RemixIcon/System/settings-fill.svg": 176877,
	"./RemixIcon/System/settings-line.svg": 935689,
	"./RemixIcon/System/share-box-fill.svg": 547111,
	"./RemixIcon/System/share-box-line.svg": 871811,
	"./RemixIcon/System/share-circle-fill.svg": 998786,
	"./RemixIcon/System/share-circle-line.svg": 379840,
	"./RemixIcon/System/share-fill.svg": 758373,
	"./RemixIcon/System/share-forward-2-fill.svg": 886791,
	"./RemixIcon/System/share-forward-2-line.svg": 48953,
	"./RemixIcon/System/share-forward-box-fill.svg": 858046,
	"./RemixIcon/System/share-forward-box-line.svg": 183405,
	"./RemixIcon/System/share-forward-fill.svg": 112413,
	"./RemixIcon/System/share-forward-line.svg": 580749,
	"./RemixIcon/System/share-line.svg": 716706,
	"./RemixIcon/System/shield-check-fill.svg": 189212,
	"./RemixIcon/System/shield-check-line.svg": 85238,
	"./RemixIcon/System/shield-cross-fill.svg": 369908,
	"./RemixIcon/System/shield-cross-line.svg": 888730,
	"./RemixIcon/System/shield-fill.svg": 835140,
	"./RemixIcon/System/shield-flash-fill.svg": 682342,
	"./RemixIcon/System/shield-flash-line.svg": 919427,
	"./RemixIcon/System/shield-keyhole-fill.svg": 500800,
	"./RemixIcon/System/shield-keyhole-line.svg": 379149,
	"./RemixIcon/System/shield-line.svg": 304015,
	"./RemixIcon/System/shield-star-fill.svg": 109232,
	"./RemixIcon/System/shield-star-line.svg": 209597,
	"./RemixIcon/System/shield-user-fill.svg": 450763,
	"./RemixIcon/System/shield-user-line.svg": 657706,
	"./RemixIcon/System/side-bar-fill.svg": 833277,
	"./RemixIcon/System/side-bar-line.svg": 320775,
	"./RemixIcon/System/spam-2-fill.svg": 344050,
	"./RemixIcon/System/spam-2-line.svg": 992019,
	"./RemixIcon/System/spam-3-fill.svg": 478282,
	"./RemixIcon/System/spam-3-line.svg": 392845,
	"./RemixIcon/System/spam-fill.svg": 261283,
	"./RemixIcon/System/spam-line.svg": 151525,
	"./RemixIcon/System/star-fill.svg": 448659,
	"./RemixIcon/System/star-half-fill.svg": 72611,
	"./RemixIcon/System/star-half-line.svg": 409713,
	"./RemixIcon/System/star-half-s-fill.svg": 987163,
	"./RemixIcon/System/star-half-s-line.svg": 781301,
	"./RemixIcon/System/star-line.svg": 884331,
	"./RemixIcon/System/star-s-fill.svg": 461318,
	"./RemixIcon/System/star-s-line.svg": 345927,
	"./RemixIcon/System/subtract-fill.svg": 633343,
	"./RemixIcon/System/subtract-line.svg": 992686,
	"./RemixIcon/System/thumb-down-fill.svg": 283560,
	"./RemixIcon/System/thumb-down-line.svg": 269510,
	"./RemixIcon/System/thumb-up-fill.svg": 702048,
	"./RemixIcon/System/thumb-up-line.svg": 426158,
	"./RemixIcon/System/time-fill.svg": 26320,
	"./RemixIcon/System/time-line.svg": 891756,
	"./RemixIcon/System/timer-2-fill.svg": 127655,
	"./RemixIcon/System/timer-2-line.svg": 192462,
	"./RemixIcon/System/timer-fill.svg": 409652,
	"./RemixIcon/System/timer-flash-fill.svg": 75726,
	"./RemixIcon/System/timer-flash-line.svg": 292765,
	"./RemixIcon/System/timer-line.svg": 349191,
	"./RemixIcon/System/toggle-fill.svg": 596274,
	"./RemixIcon/System/toggle-line.svg": 212972,
	"./RemixIcon/System/upload-2-fill.svg": 726448,
	"./RemixIcon/System/upload-2-line.svg": 636568,
	"./RemixIcon/System/upload-cloud-2-fill.svg": 128074,
	"./RemixIcon/System/upload-cloud-2-line.svg": 369195,
	"./RemixIcon/System/upload-cloud-fill.svg": 950907,
	"./RemixIcon/System/upload-cloud-line.svg": 476381,
	"./RemixIcon/System/upload-fill.svg": 129958,
	"./RemixIcon/System/upload-line.svg": 119360,
	"./RemixIcon/System/zoom-in-fill.svg": 595361,
	"./RemixIcon/System/zoom-in-line.svg": 658917,
	"./RemixIcon/System/zoom-out-fill.svg": 421890,
	"./RemixIcon/System/zoom-out-line.svg": 254355,
	"./RemixIcon/User/account-box-fill.svg": 296870,
	"./RemixIcon/User/account-box-line.svg": 634541,
	"./RemixIcon/User/account-circle-fill.svg": 838910,
	"./RemixIcon/User/account-circle-line.svg": 903722,
	"./RemixIcon/User/account-pin-box-fill.svg": 397739,
	"./RemixIcon/User/account-pin-box-line.svg": 420282,
	"./RemixIcon/User/account-pin-circle-fill.svg": 985248,
	"./RemixIcon/User/account-pin-circle-line.svg": 416884,
	"./RemixIcon/User/admin-fill.svg": 127458,
	"./RemixIcon/User/admin-line.svg": 402964,
	"./RemixIcon/User/aliens-fill.svg": 267707,
	"./RemixIcon/User/aliens-line.svg": 16583,
	"./RemixIcon/User/bear-smile-fill.svg": 255125,
	"./RemixIcon/User/bear-smile-line.svg": 375904,
	"./RemixIcon/User/body-scan-fill.svg": 228291,
	"./RemixIcon/User/body-scan-line.svg": 568890,
	"./RemixIcon/User/contacts-fill.svg": 126565,
	"./RemixIcon/User/contacts-line.svg": 994262,
	"./RemixIcon/User/criminal-fill.svg": 710582,
	"./RemixIcon/User/criminal-line.svg": 899180,
	"./RemixIcon/User/emotion-2-fill.svg": 510200,
	"./RemixIcon/User/emotion-2-line.svg": 760594,
	"./RemixIcon/User/emotion-fill.svg": 795621,
	"./RemixIcon/User/emotion-happy-fill.svg": 169264,
	"./RemixIcon/User/emotion-happy-line.svg": 601751,
	"./RemixIcon/User/emotion-laugh-fill.svg": 362948,
	"./RemixIcon/User/emotion-laugh-line.svg": 746643,
	"./RemixIcon/User/emotion-line.svg": 243447,
	"./RemixIcon/User/emotion-normal-fill.svg": 391212,
	"./RemixIcon/User/emotion-normal-line.svg": 327808,
	"./RemixIcon/User/emotion-sad-fill.svg": 337062,
	"./RemixIcon/User/emotion-sad-line.svg": 9453,
	"./RemixIcon/User/emotion-unhappy-fill.svg": 751847,
	"./RemixIcon/User/emotion-unhappy-line.svg": 724175,
	"./RemixIcon/User/genderless-fill.svg": 552938,
	"./RemixIcon/User/genderless-line.svg": 707922,
	"./RemixIcon/User/ghost-2-fill.svg": 232274,
	"./RemixIcon/User/ghost-2-line.svg": 625402,
	"./RemixIcon/User/ghost-fill.svg": 1665,
	"./RemixIcon/User/ghost-line.svg": 426480,
	"./RemixIcon/User/ghost-smile-fill.svg": 470611,
	"./RemixIcon/User/ghost-smile-line.svg": 860795,
	"./RemixIcon/User/group-2-fill.svg": 244082,
	"./RemixIcon/User/group-2-line.svg": 270303,
	"./RemixIcon/User/group-fill.svg": 10043,
	"./RemixIcon/User/group-line.svg": 897813,
	"./RemixIcon/User/men-fill.svg": 125080,
	"./RemixIcon/User/men-line.svg": 176949,
	"./RemixIcon/User/mickey-fill.svg": 547129,
	"./RemixIcon/User/mickey-line.svg": 405298,
	"./RemixIcon/User/open-arm-fill.svg": 422028,
	"./RemixIcon/User/open-arm-line.svg": 870017,
	"./RemixIcon/User/parent-fill.svg": 910299,
	"./RemixIcon/User/parent-line.svg": 319590,
	"./RemixIcon/User/robot-fill.svg": 416543,
	"./RemixIcon/User/robot-line.svg": 590732,
	"./RemixIcon/User/skull-2-fill.svg": 708546,
	"./RemixIcon/User/skull-2-line.svg": 439313,
	"./RemixIcon/User/skull-fill.svg": 609310,
	"./RemixIcon/User/skull-line.svg": 832018,
	"./RemixIcon/User/spy-fill.svg": 277419,
	"./RemixIcon/User/spy-line.svg": 689624,
	"./RemixIcon/User/star-smile-fill.svg": 320612,
	"./RemixIcon/User/star-smile-line.svg": 876942,
	"./RemixIcon/User/team-fill.svg": 390283,
	"./RemixIcon/User/team-line.svg": 228904,
	"./RemixIcon/User/travesti-fill.svg": 424318,
	"./RemixIcon/User/travesti-line.svg": 67573,
	"./RemixIcon/User/user-2-fill.svg": 874690,
	"./RemixIcon/User/user-2-line.svg": 960789,
	"./RemixIcon/User/user-3-fill.svg": 108242,
	"./RemixIcon/User/user-3-line.svg": 294166,
	"./RemixIcon/User/user-4-fill.svg": 832935,
	"./RemixIcon/User/user-4-line.svg": 266835,
	"./RemixIcon/User/user-5-fill.svg": 100718,
	"./RemixIcon/User/user-5-line.svg": 436668,
	"./RemixIcon/User/user-6-fill.svg": 272817,
	"./RemixIcon/User/user-6-line.svg": 17410,
	"./RemixIcon/User/user-add-fill.svg": 481112,
	"./RemixIcon/User/user-add-line.svg": 205153,
	"./RemixIcon/User/user-fill.svg": 555217,
	"./RemixIcon/User/user-follow-fill.svg": 7953,
	"./RemixIcon/User/user-follow-line.svg": 379144,
	"./RemixIcon/User/user-heart-fill.svg": 786832,
	"./RemixIcon/User/user-heart-line.svg": 955311,
	"./RemixIcon/User/user-line.svg": 66217,
	"./RemixIcon/User/user-location-fill.svg": 302886,
	"./RemixIcon/User/user-location-line.svg": 176191,
	"./RemixIcon/User/user-received-2-fill.svg": 668467,
	"./RemixIcon/User/user-received-2-line.svg": 591082,
	"./RemixIcon/User/user-received-fill.svg": 894594,
	"./RemixIcon/User/user-received-line.svg": 261530,
	"./RemixIcon/User/user-search-fill.svg": 238374,
	"./RemixIcon/User/user-search-line.svg": 718998,
	"./RemixIcon/User/user-settings-fill.svg": 534258,
	"./RemixIcon/User/user-settings-line.svg": 907103,
	"./RemixIcon/User/user-shared-2-fill.svg": 556089,
	"./RemixIcon/User/user-shared-2-line.svg": 152755,
	"./RemixIcon/User/user-shared-fill.svg": 231666,
	"./RemixIcon/User/user-shared-line.svg": 661418,
	"./RemixIcon/User/user-smile-fill.svg": 338494,
	"./RemixIcon/User/user-smile-line.svg": 322313,
	"./RemixIcon/User/user-star-fill.svg": 93768,
	"./RemixIcon/User/user-star-line.svg": 170419,
	"./RemixIcon/User/user-unfollow-fill.svg": 252586,
	"./RemixIcon/User/user-unfollow-line.svg": 498404,
	"./RemixIcon/User/user-voice-fill.svg": 736237,
	"./RemixIcon/User/user-voice-line.svg": 289831,
	"./RemixIcon/User/women-fill.svg": 978715,
	"./RemixIcon/User/women-line.svg": 725205,
	"./RemixIcon/Weather/blaze-fill.svg": 625978,
	"./RemixIcon/Weather/blaze-line.svg": 747502,
	"./RemixIcon/Weather/celsius-fill.svg": 184074,
	"./RemixIcon/Weather/celsius-line.svg": 311747,
	"./RemixIcon/Weather/cloud-windy-fill.svg": 456161,
	"./RemixIcon/Weather/cloud-windy-line.svg": 285837,
	"./RemixIcon/Weather/cloudy-2-fill.svg": 560565,
	"./RemixIcon/Weather/cloudy-2-line.svg": 921031,
	"./RemixIcon/Weather/cloudy-fill.svg": 996941,
	"./RemixIcon/Weather/cloudy-line.svg": 228911,
	"./RemixIcon/Weather/drizzle-fill.svg": 76271,
	"./RemixIcon/Weather/drizzle-line.svg": 371245,
	"./RemixIcon/Weather/earthquake-fill.svg": 469502,
	"./RemixIcon/Weather/earthquake-line.svg": 524434,
	"./RemixIcon/Weather/fahrenheit-fill.svg": 423615,
	"./RemixIcon/Weather/fahrenheit-line.svg": 928750,
	"./RemixIcon/Weather/fire-fill.svg": 515662,
	"./RemixIcon/Weather/fire-line.svg": 668468,
	"./RemixIcon/Weather/flashlight-fill.svg": 557493,
	"./RemixIcon/Weather/flashlight-line.svg": 459491,
	"./RemixIcon/Weather/flood-fill.svg": 479070,
	"./RemixIcon/Weather/flood-line.svg": 569969,
	"./RemixIcon/Weather/foggy-fill.svg": 304134,
	"./RemixIcon/Weather/foggy-line.svg": 150098,
	"./RemixIcon/Weather/hail-fill.svg": 565157,
	"./RemixIcon/Weather/hail-line.svg": 506773,
	"./RemixIcon/Weather/haze-2-fill.svg": 934905,
	"./RemixIcon/Weather/haze-2-line.svg": 381571,
	"./RemixIcon/Weather/haze-fill.svg": 52909,
	"./RemixIcon/Weather/haze-line.svg": 153779,
	"./RemixIcon/Weather/heavy-showers-fill.svg": 543942,
	"./RemixIcon/Weather/heavy-showers-line.svg": 656796,
	"./RemixIcon/Weather/meteor-fill.svg": 389102,
	"./RemixIcon/Weather/meteor-line.svg": 970143,
	"./RemixIcon/Weather/mist-fill.svg": 647697,
	"./RemixIcon/Weather/mist-line.svg": 97278,
	"./RemixIcon/Weather/moon-clear-fill.svg": 796282,
	"./RemixIcon/Weather/moon-clear-line.svg": 525836,
	"./RemixIcon/Weather/moon-cloudy-fill.svg": 708827,
	"./RemixIcon/Weather/moon-cloudy-line.svg": 505998,
	"./RemixIcon/Weather/moon-fill.svg": 712979,
	"./RemixIcon/Weather/moon-foggy-fill.svg": 397608,
	"./RemixIcon/Weather/moon-foggy-line.svg": 439645,
	"./RemixIcon/Weather/moon-line.svg": 432883,
	"./RemixIcon/Weather/rainbow-fill.svg": 418025,
	"./RemixIcon/Weather/rainbow-line.svg": 35288,
	"./RemixIcon/Weather/rainy-fill.svg": 395905,
	"./RemixIcon/Weather/rainy-line.svg": 626394,
	"./RemixIcon/Weather/showers-fill.svg": 199800,
	"./RemixIcon/Weather/showers-line.svg": 324208,
	"./RemixIcon/Weather/snowy-fill.svg": 535724,
	"./RemixIcon/Weather/snowy-line.svg": 357088,
	"./RemixIcon/Weather/sun-cloudy-fill.svg": 282384,
	"./RemixIcon/Weather/sun-cloudy-line.svg": 627245,
	"./RemixIcon/Weather/sun-fill.svg": 749944,
	"./RemixIcon/Weather/sun-foggy-fill.svg": 689421,
	"./RemixIcon/Weather/sun-foggy-line.svg": 767751,
	"./RemixIcon/Weather/sun-line.svg": 62930,
	"./RemixIcon/Weather/temp-cold-fill.svg": 886044,
	"./RemixIcon/Weather/temp-cold-line.svg": 870583,
	"./RemixIcon/Weather/temp-hot-fill.svg": 612923,
	"./RemixIcon/Weather/temp-hot-line.svg": 47951,
	"./RemixIcon/Weather/thunderstorms-fill.svg": 831243,
	"./RemixIcon/Weather/thunderstorms-line.svg": 850796,
	"./RemixIcon/Weather/tornado-fill.svg": 370026,
	"./RemixIcon/Weather/tornado-line.svg": 437032,
	"./RemixIcon/Weather/typhoon-fill.svg": 269636,
	"./RemixIcon/Weather/typhoon-line.svg": 433053,
	"./RemixIcon/Weather/windy-fill.svg": 444494,
	"./RemixIcon/Weather/windy-line.svg": 61726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140240;